import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { _Api, Api_form } from "../common/api/_call";
import Select, { components } from "react-select";
import { Saleperson } from "../common/graphql/commonlayouts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomerSearchModal from "../common/module/customerSearch";
import "../catalog/catalog.scss";
import "../checkout/checkout.scss";
import {
  error,
  success,
  loading,
  Updateloading,
} from "../common/helpers/toastify";
import { useSelector } from "react-redux";
import { toFormatPrice } from "../common/helpers/function";
import EmailModal, { openPosEmailModal } from "../common/Modals/EmailModal";
import { useTranslation } from "react-i18next";
import PaymentLayby from "../common/Modals/PaymentLaybyModal";
import PaymentInstall from "../common/Modals/PaymentInstallModal";
import Savelaybymodal from "../common/Modals/Savelaybymodal";
import Saveinstallmentmodal from "../common/Modals/Saveinstallmentmodal";
import AddCustomerAddressPopup from "../checkout/addCustomerPopup/AddCustomerAddressPopup";
import addressicon from "../../assets/images/pos/icons/script.png";
import CustomerInformation from "../../admin/customers/customerInformation/CustomerInformation";
import notaddressicon from "../../assets/images/pos/icons/scriptnot.png";
import StripeCheckout from "../checkout/StripePayment.js";
import { store } from "../../source/index";
import ViewPaymentLogsModel from "../checkout/viewPaymentLogsModel.js";
import clrbtnimg from "../../assets/images/clrbtnimg.png";
import PayPalButton from "pos/checkout/PayPalPayment";
import CregisPayment from "../checkout/CregisPayment";
import Addmorebtnimg from "../../assets/images/Addmore.png";
import UploadCameraimg from "../../assets/images/uploadcamera.png";
import Laptop from "../../assets/images/laptop.png";
import SaveBtn from "../../assets/images/savebtn.png";
import ChequeImg from "../../assets/images/chequeimg.png";
import ImageUploaded from "../../assets/images/imageuploaded.png";
import SaveBtnHover from "../../assets/images/savebtnhover.png";
import { clearFaroSessionsAfterCheckout } from "../catalog/faroSession";

const resolveGatewaySlag = (method = {}) => {
  const slug = String(method?.payment_slag || "").toLowerCase();
  const label = `${method?.name || ""} ${method?.PaymentMethod || ""}`.toLowerCase();
  if (slug.includes("stripe-payment")) return "stripe-payment";
  if (slug.includes("cregis-payment") || (!slug && label.includes("cregis-payment"))) return "cregis-payment";
  if (slug.includes("paypal-payment") || (!slug && label.includes("paypal-payment"))) return "paypal-payment";
  return method?.payment_slag || "";
};

const CheckoutPayment = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  let reduxdata = store.getState();
  let OrgSettings = reduxdata?.app?.posorganisation_settings;
  const {
    UpdatedCart,
    setShowcheckout,
    order_id,
    quotationid,
    laybyid,
    order_edit,
    order_type,
    by_custom_order,
    custom_order_id,
    by_repair_order,
    order_type_reserve,
    reserve_sell,
    laybylist,
    greandtotal,
  } = props;
  const [toggleAddressCustomer, setToggleAddressCustomer] = useState(false);
  const posloc = JSON.parse(localStorage.getItem("pos-loc"));
  let calnumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00", "."];
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [cusid, setCusid] = useState();
  const [paystatement, setPaystatement] = useState("Full_Payment");
  const [loader, setLoader] = useState(false);
  const [Rechangekey, setRechangekey] = useState();
  const [installementdata, setInstallementdata] = useState([]);
  const [Currencyoption, setCurrencyoption] = useState([]);
  const [transcationcounts, setTranscationcounts] = useState({
    cash: [],
    credit_card: 0,
  });
  const [mode, setMode] = useState("cash");
  const [debitedamount, setDebitedamount] = useState({
    cash: 0,
    bank: 0,
    credit_card: 0,
    credit_notes: 0,
  });
  const [balancedue, setBalancedue] = useState(UpdatedCart?.totalamount);
  const [calnumbers, setCalnumbers] = useState("");
  const [checkcreaditamount, setCheckcreaditamount] = useState([]);
  const [exchange, setExchange] = useState();
  const [installcof, setinstallcof] = useState(false);
  const [repaymentids, setrepaymentids] = useState();
  const [refNo, setRefNO] = useState();
  const [showorder, setShoworder] = useState(false);
  const [chnagecurrencies, setChnagecurrencies] = useState(posloc?.curr);
  const [checkoutdetails, setcheckoutdetails] = useState();
  const [pdfLoading, setPdfLoading] = useState(false);
  const [otpnumber, setOtpnumber] = useState([]);
  const [credit_noteoption, setCredit_noteoption] = useState(
    UpdatedCart?.credit_note_options,
  );
  const [credit_noteids, setcredit_noteids] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [banknameIB, setBanknameIB] = useState([]);
  const [banknameCheque, setBanknameCheque] = useState([]);
  const [installdivtim, setinstalldivtim] = useState({
    installment: { label: "", value: "" },
    term: { label: "1 month", value: 1 },
    receive: [],
  });
  const [creditCardDetails, setcreditCardDetails] = useState({
    name: "",
    logo: "",
    card_name: "",
    card_number: "",
    payment_method_id: "",
    amount: "",
    Paymentmethod_type: "",
    payment_slag: "",
  });
  const [bankDetails, setBankDetails] = useState({
    transcation_date: new Date(),
    payment_method_id: "",
    ac_no: "",
    ac_name: "",
    ref_no: "",
    inst_no: "",
    amount: "",
    Paymentmethod_type: "Bank",
  });
  const [pay_data, setPay_data] = useState({
    cash: "",
    bank: [],
    IB: [],
    credit_card: [],
    credit_note: [],
    gift_card: "",
  });
  const [pay_layby_data, setPay_layby_data] = useState([]);
  const customer = useSelector((state) => state.app.customer);
  const [laybyshow, setLaybyshow] = useState(false);
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const MainDate = new Date();
  const [TransactionlaybyDate, setTransactionlaybyDate] = useState(
    new Date(MainDate.setDate(MainDate.getDate() + 7)),
  );
  const [banktransactionDate, setBanktransactionDate] = useState(new Date());
  const itemdaata = localStorage.getItem("addcustomerdtaa");
  const parsedObject = JSON.parse(itemdaata);
  const parts = location.pathname.split("/");
  const [showCalcPopover, setShowCalcPopover] = useState(false);
  const [keypadMode, setKeypadMode] = useState(null);
  const [activelist, setActivelist] = useState({ ib: true, bank: true });
  const [inputActive, setInputActive] = useState(false);
  const inputRef = useRef(null);
  const calcRef = useRef(null);
  const [Index, setIndex] = useState();
  const [payImage, setPayImage] = useState("");
  const [modalImage, setModalImage] = useState("");

  const { ValueContainer, Placeholder } = components;
  const installdivide = [
    {
      label: 10,
      value: 10,
    },
    {
      label: 20,
      value: 20,
    },
    {
      label: 30,
      value: 30,
    },
  ];
  const installtime = [
    {
      label: "1 month",
      value: 1,
    },
    {
      label: "2 month ",
      value: 2,
    },
    {
      label: "3 month",
      value: 3,
    },
  ];
  const [printparmission, setPrintparmission] = useState(0);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  useEffect(() => {
    if (
      parmissiondatashow?.pos_custom_order?.View ||
      parmissiondatashow?.pos_refund?.View ||
      parmissiondatashow?.pos_deposit?.View ||
      parmissiondatashow?.pos_coupon?.View ||
      parmissiondatashow?.pos_reserve?.View ||
      parmissiondatashow?.pos_repair_order?.View ||
      parmissiondatashow?.pos_mix_and_match?.View
    )
      setPrintparmission(1);
  }, [parmissiondatashow]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        calcRef.current &&
        !calcRef.current.contains(e.target)
      ) {
        setShowCalcPopover(false);
        setKeypadMode(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (banknameIB && banknameIB.length > 0) {
      const firstOption = banknameIB[0];
      setQrCodePaymentId({
        value: firstOption.value,
        PaymentMethod: firstOption.PaymentMethod,
        PaymentMethodLogo: firstOption.PaymentMethodLogo,
        name: firstOption?.name,
        payment_slag: firstOption?.payment_slag,
      });
      // generateQRCode();
    }
  }, [banknameIB]);

  const preCheckoutValidation = () => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return false;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return false;
    }
    if (
      generalsettings?.data?.generalsetup?.kyc === "1" &&
      customer?.kycStatus !== "Approved" &&
      customer?.kycStatus !== "Completed"
    ) {
      error(t("Complete your KYC to continue"));
      return false;
    }
    return true;
  };

  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null,
        )}
      </ValueContainer>
    );
  };
  const callinstallment = async () => {
    try {
      const postdata = {
        installment: installdivtim?.installment?.value,
        term: installdivtim?.term?.value,
        status_type: UpdatedCart?.sell_info?.status_type,
        amount: balancedue ? balancedue : UpdatedCart?.totalamount,
      };
      let res = await _Api(
        postdata,
        `api/v1/POS/receive/calculateInstallments`,
      );
      if (res?.code === 200) {
        setInstallementdata(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const removeidsoninstrecieve = (i) => {
    let instarray = [...installdivtim?.receive];
    let array = [];
    instarray?.forEach((result) => {
      if (result?.id !== "inst_" + i) {
        array.push(result);
      }
    });
    setinstalldivtim((existing) => ({ ...existing, receive: array }));
  };
  const creditCard = (event) => {
    if (isActive === false && !calnumbers) {
      error(t("Please enter the amount first"));
      return false;
    }
    setIsActive((current) => !current);
  };
  const callnumber = (number) => {
    let actual = "";
    if (number === "Backspace") {
      actual = calnumbers.slice(0, -1);
      setCalnumbers(actual);
    } else {
      const re = /^[0-9]*\.?[0-9]*$/;
      let valid = re.test(number);
      if (valid) {
        actual = calnumbers + number;
        setCalnumbers(actual);
      }
    }
  };
  const changecreditnoteamount = (key, value, id, oldamount, gifi) => {
    let array = [...credit_noteoption];
    let credit_idsarray = [...credit_noteids];
    if (!gifi) {
      if (isNaN(value)) {
        value = 0;
      }
      if (value <= oldamount) {
        array[key] = {
          ...array[key],
          amount: parseFloat(value),
        };
        credit_idsarray.forEach((creditid) => {
          if (creditid?.id === id) {
            creditid["amount"] = parseFloat(value);
          }
        });
        setcredit_noteids(credit_idsarray);
        setCredit_noteoption(array);
      } else {
        error(t("Amount must be lesser than") + " " + oldamount);
      }
    } else {
      if (isNaN(value)) {
        value = 0;
      }
      if (value <= oldamount) {
        array[key] = {
          ...array[key],
          amount: parseFloat(value),
        };
        credit_idsarray.forEach((creditid) => {
          if (creditid?.gift_card_id === id) {
            creditid["amount"] = parseFloat(value);
          }
        });
        setcredit_noteids(credit_idsarray);
        setCredit_noteoption(array);
      } else {
        error(t("Amount must be lesser than") + " " + oldamount);
      }
    }
  };
  const getcredit_noteids = (e, result, key, gifi) => {
    let array = [...credit_noteoption];
    if (array[key]?.diff_currency) {
      error(
        "Apologies for the inconvenience! This credit note is in a different currency and cannot be encashed here",
      );
      return;
    }
    if (e.target.checked) {
      setcredit_noteids([...credit_noteids, result]);
      array[key] = {
        ...array[key],
        classadd: true,
      };
      setCredit_noteoption(array);
    } else {
      if (!gifi) {
        setcredit_noteids((current) =>
          current.filter((item) => item?.id !== e.target.id),
        );
      } else {
        setcredit_noteids((current) =>
          current.filter((item) => item?.gift_card_id !== e.target.id),
        );
      }
      array[key] = {
        ...array[key],
        classadd: false,
      };
      setCredit_noteoption(array);
    }
  };

  const getCurrencyRate = (currencyCode, fallback = 1) => {
    const code = String(currencyCode || "")
      .trim()
      .toUpperCase();
    if (!code) return fallback;
    const matched = Currencyoption?.find(
      (item) =>
        String(item?.currency || "")
          .trim()
          .toUpperCase() === code,
    );
    const rate = Number(matched?.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : fallback;
  };

  const safeRateForDivision = (rateValue) => {
    const n = Number(rateValue);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };
  const roundCurrency = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.round((n + Number.EPSILON) * 100) / 100;
  };
  const FX_ROUNDING_TOLERANCE = 0.2;

  const parseNumericInput = (value) => {
    if (value == null) return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    const normalized = String(value).replace(/,/g, "").trim();
    const n = Number(normalized);
    return Number.isFinite(n) ? n : 0;
  };

  const isWithinDueTolerance = (amount, dueAmount) => {
    const amountValue = parseNumericInput(amount);
    const dueValue = parseNumericInput(dueAmount);
    if (!Number.isFinite(amountValue) || !Number.isFinite(dueValue))
      return false;
    return (
      amountValue <= dueValue || amountValue - dueValue <= FX_ROUNDING_TOLERANCE
    );
  };

  const isCollectAmountMatch = (
    inputAmount,
    dueAmount = balancedue,
    selectedRate = exchange,
  ) => {
    const entered = parseNumericInput(inputAmount);
    if (!Number.isFinite(entered) || entered <= 0) return false;
    const collectAmount = computeRequiredCashToCollect(dueAmount, selectedRate);
    if (!Number.isFinite(collectAmount) || collectAmount <= 0) return false;
    return Math.abs(entered - collectAmount) <= 0.01;
  };

  const computeCashInStoreCurrencyRaw = (
    cashAmount,
    selectedRate = exchange,
  ) => {
    const amount = parseNumericInput(cashAmount);
    if (!Number.isFinite(amount) || amount <= 0) return 0;

    const paidCurrency = String(chnagecurrencies || "")
      .trim()
      .toUpperCase();
    const storeCurrency = String(posloc?.curr || "")
      .trim()
      .toUpperCase();
    const storeRate = safeRateForDivision(getCurrencyRate(storeCurrency, 1));

    let equivalentRate;
    if (!paidCurrency || paidCurrency === storeCurrency) {
      equivalentRate = 1;
    } else {
      const editedRate = Number(selectedRate);
      equivalentRate =
        Number.isFinite(editedRate) && editedRate > 0
          ? editedRate
          : safeRateForDivision(getCurrencyRate(paidCurrency, 1)) / storeRate;
    }

    if (
      !Number.isFinite(equivalentRate) ||
      equivalentRate <= 0 ||
      storeRate <= 0
    )
      return 0;
    return equivalentRate * amount;
  };

  const computeCashInStoreCurrency = (cashAmount, selectedRate = exchange) => {
    return roundCurrency(
      computeCashInStoreCurrencyRaw(cashAmount, selectedRate),
    );
  };

  const computeRequiredCashToCollectRaw = (
    dueAmount = balancedue,
    selectedRate = exchange,
  ) => {
    const due = parseNumericInput(dueAmount);
    if (!Number.isFinite(due) || due <= 0) return 0;
    const equivalentRate = Number(selectedRate);
    if (!Number.isFinite(equivalentRate) || equivalentRate <= 0) return 0;
    return due / equivalentRate;
  };

  const computeRequiredCashToCollect = (
    dueAmount = balancedue,
    selectedRate = exchange,
  ) => {
    return roundCurrency(
      computeRequiredCashToCollectRaw(dueAmount, selectedRate),
    );
  };

  const debitedprice = (transID = "", status, overrideAmount, cryptoMeta = {}) => {
    if (mode === "cash") {
      const rate = computeCashInStoreCurrency(calnumbers, exchange);
      const dueAmount = parseNumericInput(balancedue);
      const shouldSettleByCollect = isCollectAmountMatch(
        calnumbers,
        dueAmount,
        exchange,
      );
      const rateToApply = shouldSettleByCollect
        ? dueAmount
        : isWithinDueTolerance(rate, dueAmount)
          ? Math.min(rate, dueAmount)
          : rate;
      const depositCash = parseNumericInput(UpdatedCart?.deposit_details?.cash);
      if (!rate || rateToApply <= 0) {
        error("cash Amount is Not Valid");
        return;
      }
      if (depositCash > 0) {
        if (
          !isWithinDueTolerance(rateToApply, depositCash) ||
          debitedamount?.cash >= depositCash
        ) {
          const remainingCash = Math.max(
            0,
            roundCurrency(depositCash - parseNumericInput(debitedamount?.cash)),
          );
          error(
            t(
              remainingCash > 0
                ? "Amount is less than " + remainingCash
                : "cash Amount is Not Valid",
            ),
          );
          return;
        }
      }
      if (isWithinDueTolerance(rateToApply, dueAmount)) {
        const updatedCashDebited = roundCurrency(
          parseNumericInput(debitedamount?.cash) + rateToApply,
        );
        const updatedBalanceDue = roundCurrency(dueAmount - rateToApply);
        setTranscationcounts((existingpay) => ({
          ...existingpay,
          cash: [
            ...existingpay?.cash,
            {
              exchange: exchange,
              calnumber: calnumbers,
              currency: chnagecurrencies,
            },
          ],
        }));
        setBalancedue(updatedBalanceDue);
        setDebitedamount((existingValues) => ({
          ...existingValues,
          cash: updatedCashDebited,
        }));
        setExchange("");
        setCalnumbers("");
        setExchange("");
        setChnagecurrencies(posloc?.curr);
        setPay_data((existingIds) => ({
          ...existingIds,
          cash: {
            payment_method_id: UpdatedCart?.payment_Options?.Cash?.length
              ? UpdatedCart?.payment_Options?.Cash[0]?.id
              : "",
            Paymentmethod_type: "cash",
            amount: updatedCashDebited,
          },
        }));
      } else {
        if (dueAmount <= 0) {
          if (calnumbers) {
            setBalancedue(
              roundCurrency(
                parseNumericInput(debitedamount?.cash) - rateToApply,
              ),
            );
            setDebitedamount((existingValues) => ({
              ...existingValues,
              cash: roundCurrency(rateToApply),
            }));
            setExchange("");
            setCalnumbers("");
            setExchange("");
            setChnagecurrencies(posloc?.curr);
            setPay_data((existingIds) => ({
              ...existingIds,
              cash: {
                payment_method_id: UpdatedCart?.payment_Options?.Cash?.length
                  ? UpdatedCart?.payment_Options?.Cash[0]?.id
                  : "",
                Paymentmethod_type: "cash",
                amount: roundCurrency(rateToApply),
              },
            }));
          }
        } else {
          error("cash Amount is Not Valid");
        }
      }
    }
    if (mode === "credit-card") {
      const paymentAmount = parseFloat(
        overrideAmount !== undefined && overrideAmount !== null && overrideAmount !== ""
          ? overrideAmount
          : calnumbers,
      );
      if (
        UpdatedCart?.deposit_details?.credit_card !== 0 ||
        UpdatedCart?.deposit_details?.cash ||
        UpdatedCart?.deposit_details?.bank
      ) {
        if (
          paymentAmount > UpdatedCart?.deposit_details?.credit_card ||
          debitedamount?.credit_card >=
            UpdatedCart?.deposit_details?.credit_card
        ) {
          const remainingCredit = Math.max(
            0,
            roundCurrency(
              parseNumericInput(UpdatedCart?.deposit_details?.credit_card) -
                parseNumericInput(debitedamount?.credit_card),
            ),
          );
          error(t("Amount is less than " + remainingCredit));
          return;
        }
      }
      if (!Number.isFinite(paymentAmount) || paymentAmount <= 0) {
        error(t("Amount is not Valid"));
        return;
      }
      if (paymentAmount <= parseFloat(balancedue)) {
        let onecredit = { ...creditCardDetails };
        setBalancedue(
          parseFloat(balancedue).toFixed(2) - paymentAmount.toFixed(2),
        );
        setTranscationcounts((existingValues) => ({
          ...existingValues,
          credit_card: transcationcounts?.credit_card + 1,
        }));
        setDebitedamount((existingValues) => ({
          ...existingValues,
          credit_card: debitedamount?.credit_card + paymentAmount,
        }));
        setCalnumbers("");
        onecredit = {
          ...onecredit,
          amount: paymentAmount,
          client_reference_id: qrCodeTractionsId || transID,
        };
        if (onecredit?.payment_slag === "paypal-payment" || onecredit?.payment_slag === "cregis-payment") {
          onecredit = {
            ...onecredit,
            transID,
            payment: status,
          };
        }
        if (onecredit?.payment_slag === "cregis-payment" && cryptoMeta) {
          onecredit = {
            ...onecredit,
            cryptoCurrency:
              cryptoMeta?.cryptoCurrency ||
              cryptoMeta?.cryptocurrency ||
              cryptoMeta?.crypto_currency ||
              "",
            cryptocurrency:
              cryptoMeta?.cryptocurrency ||
              cryptoMeta?.cryptoCurrency ||
              cryptoMeta?.crypto_currency ||
              "",
            crypto_currency:
              cryptoMeta?.crypto_currency ||
              cryptoMeta?.cryptoCurrency ||
              cryptoMeta?.cryptocurrency ||
              "",
            network: cryptoMeta?.network || cryptoMeta?.blockchain || "",
            blockchain: cryptoMeta?.blockchain || cryptoMeta?.network || "",
            token_name: cryptoMeta?.token_name || "",
            receive_currency: cryptoMeta?.receive_currency || "",
            receive_amount: cryptoMeta?.receive_amount || "",
          };
        }
        setPay_data((prev) => ({
          ...prev, // keep other keys unchanged
          credit_card: [...prev.credit_card, onecredit], // create a new array
        }));
        setcreditCardDetails({
          name: "",
          logo: "",
          card_name: "",
          card_number: "",
          payment_method_id: "",
          amount: "",
          Paymentmethod_type: "",
          payment_slag: "",
        });
        setIsActive((current) => !current);
      } else {
        error(t("Amount is not Valid"));
        return;
      }
    }

    if (mode === "bankcheque") {
      if (
        UpdatedCart?.deposit_details?.bank !== 0 ||
        UpdatedCart?.deposit_details?.cash ||
        UpdatedCart?.deposit_details?.credit_card
      ) {
        if (
          calnumbers > UpdatedCart?.deposit_details?.bank ||
          debitedamount?.bank >= UpdatedCart?.deposit_details?.bank
        ) {
          const remainingBank = Math.max(
            0,
            roundCurrency(
              parseNumericInput(UpdatedCart?.deposit_details?.bank) -
                parseNumericInput(debitedamount?.bank),
            ),
          );
          error(t("Amount is less than " + remainingBank));
          return;
        }
      }
      if (parseFloat(calnumbers) <= parseFloat(balancedue)) {
        let onebank = { ...bankDetails };
        setBalancedue(
          parseFloat(balancedue).toFixed(2) - parseFloat(calnumbers).toFixed(2),
        );
        setDebitedamount((existingValues) => ({
          ...existingValues,
          bank: parseFloat(debitedamount?.bank) + parseFloat(calnumbers),
        }));
        setCalnumbers("");
        onebank = { ...onebank, amount: calnumbers };
        onebank = { ...onebank, amount: calnumbers };
        setPay_data((prev) => ({
          ...prev, // keep other keys intact
          bank: [...prev.bank, onebank], // create a new array with the new item
        }));
        setActivelist((prev) => ({ ...prev, bank: false }));
        setPayImage();
        setSelectedImage();
        setBankDetails({
          transcation_date: new Date(),
          payment_method_id: "",
          ac_no: "",
          ac_name: "",
          ref_no: "",
          inst_no: "",
          amount: "",
          Paymentmethod_type: "",
          payment_slag: "",
        });
      } else {
        error(t("Amount is not Valid"));
        return;
      }
    }

    if (mode === "bankib") {
      if (!transID) {
        error(t("Please scan QR code to complete payment"));
        return;
      }
      if (
        UpdatedCart?.deposit_details?.bank !== 0 ||
        UpdatedCart?.deposit_details?.cash ||
        UpdatedCart?.deposit_details?.credit_card
      ) {
        if (
          calnumbers > UpdatedCart?.deposit_details?.bank ||
          debitedamount?.bank >= UpdatedCart?.deposit_details?.bank
        ) {
          const remainingBank = Math.max(
            0,
            roundCurrency(
              parseNumericInput(UpdatedCart?.deposit_details?.bank) -
                parseNumericInput(debitedamount?.bank),
            ),
          );
          error(t("Amount is less than " + remainingBank));
          return;
        }
      }
      if (parseFloat(calnumbers) <= parseFloat(balancedue)) {
        let onebank = { ...bankDetails };

        setBalancedue(
          parseFloat(balancedue).toFixed(2) - parseFloat(calnumbers).toFixed(2),
        );
        setDebitedamount((existingValues) => ({
          ...existingValues,
          bank: parseFloat(debitedamount?.bank) + parseFloat(calnumbers),
        }));
        setCalnumbers("");
        onebank = {
          ...onebank,
          amount: calnumbers,
          payment_method_id: qrCodePaymentId?.value,
          PaymentMethodLogo: qrCodePaymentId?.PaymentMethodLogo || "",
          name: qrCodePaymentId?.name,
          client_reference_id: qrCodeTractionsId,
          payment_slag: qrCodePaymentId?.payment_slag,
          transID,
          paymentAttchment: bankDetails?.paymentAttchment,
        };

        setPay_data((prev) => ({
          ...prev, // keep other keys unchanged
          IB: [...prev.IB, onebank], // create a new array with the new item
        }));
        setActivelist((prev) => ({ ...prev, ib: false }));
        setPayImage();
        setSelectedImage();
        setBankDetails({
          transcation_date: new Date(),
          payment_method_id: "",
          ac_no: "",
          ac_name: "",
          ref_no: "",
          inst_no: "",
          amount: "",
          Paymentmethod_type: "",
          payment_slag: "",
        });
        setQrCodeImage(null);
        setQrCodeTractionsId("");
        setQrCodeMessage("Loading QR Code...");
      } else {
        error(t("Amount is not Valid"));
        return;
      }
    }
  };

  const change_creditnote = () => {
    if (mode === "credit-note") {
      let getarray = [...checkcreaditamount];
      let creditnoteoptions = [...credit_noteoption];
      let debited_amount = { ...debitedamount };
      if (credit_noteids?.length) {
        credit_noteids.forEach((result) => {
          // let array = checkcreaditamount.filter(item => item?.id === result?.id);
          // let array=[];
          // if(result?.gift_card_id){
          //  array=checkcreaditamount.filter(item => item?.gift_card_id === result?.gift_card_id);
          // }
          // else{
          //   array=checkcreaditamount.filter(item => item?.id === result?.id);
          // }
          let index = result?.gift_card_id
            ? getarray.findIndex(
                (item) => item.gift_card_id === result.gift_card_id,
              )
            : getarray.findIndex((item) => item.id === result.id);

          if (index !== -1) {
            // if (result?.old_amount >= array[0]?.amount) {
            //   array[0]['amount'] = parseFloat(array[0]?.amount) + parseFloat(result?.amount);
            //   getarray.map(obj => array.find(o => o.id === obj.id) || obj);
            //   setCheckcreaditamount(getarray);
            // }
            let updated = {
              ...getarray[index],
              amount:
                parseFloat(getarray[index].amount) + parseFloat(result.amount),
            };

            getarray[index] = updated;
            setCheckcreaditamount(getarray);
          } else {
            setCheckcreaditamount((prev) => [
              ...prev,
              {
                id: result?.id,
                amount: parseFloat(result?.amount),
                gift_card_id: result?.gift_card_id,
                gift_card_number: result?.Ref_No,
              },
            ]);
            getarray.push({
              id: result?.id,
              amount: parseFloat(result?.amount),
              gift_card_id: result?.gift_card_id,
              gift_card_number: result?.Ref_No,
            });
          }
        });
      }
      if (
        parseFloat(balancedue) >=
        parseFloat(
          credit_noteids?.length
            ? credit_noteids?.reduce(
                (interation, val) =>
                  (interation = interation + parseFloat(val?.amount)),
                0,
              )
            : 0,
        )
      ) {
        let credit_notearray = [];
        let creditnotechangedoptionarray = [];
        let credit_noteamount = credit_noteids?.length
          ? credit_noteids?.reduce(
              (interation, val) => (interation = interation + val?.amount),
              0,
            )
          : 0;
        // if (credit_noteamount < debitedamount?.credit_notes) {
        //     console.log(credit_noteamount,debitedamount?.credit_notes,"kishnacreedit")
        //   error(t(`Valid Amount is less than ${credit_noteamount}`))
        //   return;
        // } else {
        let duebalance = 0;
        if (credit_noteids?.length) {
          for (const interation of credit_noteids) {
            duebalance += interation?.amount;
          }
        } else {
          duebalance = 0;
        }
        setBalancedue(
          parseFloat(balancedue).toFixed(2) - parseFloat(duebalance).toFixed(2),
        );
        setDebitedamount((existingValues) => ({
          ...existingValues,
          credit_notes:
            parseFloat(existingValues.credit_notes) +
            parseFloat(credit_noteamount),
        }));
        if (getarray?.length) {
          getarray.forEach((result) => {
            // delete result?.Ref_No;
            // delete result?.currency;
            // delete result?.date;
            // delete result?.type;
            credit_notearray.push({
              payment_method_id: result?.id,
              amount: result?.amount,
              gift_card_id: result?.gift_card_id,
              gift_card_number: result?.gift_card_number,
            });
          });
        }
        setPay_data((existingIds) => ({
          ...existingIds,
          credit_note: {
            ids: credit_notearray,
            amount:
              parseFloat(debited_amount.credit_notes) +
              parseFloat(credit_noteamount),
            Paymentmethod_type: "CreditNote",
          },
        }));
        credit_noteids.forEach((result) => {
          // get index of first match
          let index = result?.gift_card_id
            ? creditnoteoptions.findIndex(
                (item) => item.gift_card_id === result.gift_card_id,
              )
            : creditnoteoptions.findIndex((item) => item.id === result.id);

          // if found
          if (index !== -1) {
            let updated = {
              ...creditnoteoptions[index],
              amount:
                parseFloat(creditnoteoptions[index].old_amount) -
                parseFloat(result.amount),
              old_amount:
                parseFloat(creditnoteoptions[index].old_amount) -
                parseFloat(result.amount),
              classadd: false,
            };

            creditnoteoptions[index] = updated;

            creditnotechangedoptionarray.push(updated);
          }
        });

        setCredit_noteoption(creditnoteoptions);
        setcredit_noteids([]);
        // }
      } else {
        error(t("Amount is not Valid"));
        return;
      }
    }
  };
  const reCashPayement = (key, label) => {
    if (label === "cashpayment") {
      const editedRate = computeCashInStoreCurrency(calnumbers, exchange);
      const dueAmount = parseNumericInput(balancedue);
      const shouldSettleByCollect = isCollectAmountMatch(
        calnumbers,
        dueAmount,
        exchange,
      );
      const editedRateToApply = shouldSettleByCollect
        ? dueAmount
        : isWithinDueTolerance(editedRate, dueAmount)
          ? Math.min(editedRate, dueAmount)
          : editedRate;
      if (
        editedRateToApply > 0 &&
        isWithinDueTolerance(editedRateToApply, dueAmount)
      ) {
        let array = { ...transcationcounts };
        let pay_data_array = { ...pay_data };
        array["cash"][Rechangekey] = {
          exchange: chnagecurrencies === posloc?.curr ? "" : exchange,
          calnumber: calnumbers,
          currency: chnagecurrencies,
        };
        const subtotalRaw = array?.cash.reduce(
          (interation, val) =>
            (interation =
              interation +
              (Number(
                val?.exchange
                  ? val?.exchange
                  : safeRateForDivision(getCurrencyRate(val?.currency, 1)) /
                      safeRateForDivision(getCurrencyRate(posloc?.curr, 1)),
              ) || 0) *
                parseNumericInput(val?.calnumber)),
          0,
        );
        let subtotal = roundCurrency(subtotalRaw);
        const totalamount = roundCurrency(
          parseNumericInput(pay_data_array?.cash?.amount) +
            dueAmount -
            subtotal,
        );
        setBalancedue(totalamount);
        setDebitedamount((existingValues) => ({
          ...existingValues,
          cash: subtotal,
        }));
        pay_data_array["cash"] = {
          ...(pay_data_array["cash"] || {}),
          amount: subtotal,
        };
        setPay_data(pay_data_array);
        setTranscationcounts(array);
        setCalnumbers("");
        setExchange("");
        setrepaymentids("");
        setChnagecurrencies(posloc?.curr);
        setRechangekey("");
      } else {
        error(t("Amount is not Valid"));
      }
    } else {
      setrepaymentids("cashid");
      let array = { ...transcationcounts };
      setExchange(array?.cash[key]?.exchange);
      setCalnumbers(array?.cash[key]?.calnumber);
      setChnagecurrencies(array?.cash[key]?.currency);
      setRechangekey(key);
    }
  };
  // const reCreditCardPayment = (key) => {
  //   let array = { ...pay_data };
  //   setrepaymentids('creditcardview');
  //   setRechangekey(key);
  //   setIsActive(current => !current);
  //   setcreditCardDetails(array['credit_card'][key]);
  //   setCalnumbers(array['credit_card'][key]['amount']);
  // }
  const closePinModal = () => {
    const pinModalEl = document.getElementById("pinModal");
    if (pinModalEl) {
      pinModalEl.style.display = "none";
      pinModalEl.classList.remove("show");
      document.body.classList.remove("modal-open");
    }
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  };
  const checkoutorder = async () => {
    if (!customer?.id) {
      closePinModal();
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      closePinModal();
      error(t("SalePerson is Requried!!"));
      return;
    }
    setLoader(true);
    try {
      let postdata = {
        sell_info: UpdatedCart?.sell_info,
        payment_info: {
          debited_amount: debitedamount,
          pay_data: pay_data,
          balance_due:
            UpdatedCart?.sell_info?.totalamount - UpdatedCart?.totalamount,
          balance_deposit: UpdatedCart?.totalamount,
        },
        transaction_date: TransactionDate,
        layby_due_date: laybylist
          ? TransactionlaybyDate
          : paystatement === "LayBy"
            ? TransactionlaybyDate
            : "",
        pay_layby_data: laybylist
          ? pay_layby_data
          : paystatement === "LayBy"
            ? pay_layby_data
            : [],
        paymentMathod:
          installdivtim?.receive?.length && installcof === true
            ? "Installment"
            : paystatement,
        installment: installdivtim?.receive,
        fullinstallentlist: installementdata ? installementdata : [],
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        sales_person_name: saleperson?.label,
        order_type: order_type
          ? order_type
          : order_type_reserve
            ? order_type_reserve
            : UpdatedCart?.ordertype
              ? UpdatedCart?.ordertype
              : UpdatedCart?.sell_info?.status_type,
        order_id: order_id ? order_id : "",
        quatation_id: quotationid ? quotationid : "",
        layby_id: laybyid ? laybyid : "",
        by_custom_order: by_custom_order ? by_custom_order : "",
        custom_order_id: custom_order_id ? custom_order_id : "",
        by_repair_order: by_repair_order ? by_repair_order : "",
        reserve_sell: reserve_sell ? reserve_sell : "",
        service_enable: UpdatedCart?.service_enable,
        // shippingInfo:
        //   parts[3] !== "exchange" &&
        //   parts[3] !== "refund" &&
        //   parts[3] !== "reserve" &&
        //   parts[3] !== "receive" &&
        //   parts[3] !== "reserveproduct"
        //     ? parsedObject
        //     : {},
        shippingInfo: parsedObject,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/saveCustomOrder`);
      if (res.code === 200) {
        setLoader(false);
        setcheckoutdetails(res?.data);
        setShoworder(true);
        localStorage.removeItem("showcheckout");
        clearFaroSessionsAfterCheckout();
      } else {
        setLoader(false);
        setShoworder(false);
        error(res?.message);
        closePinModal();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const editcheckoutorder = async () => {
    if (!customer?.id) {
      closePinModal();
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      closePinModal();
      error(t("SalePerson is Requried!!"));
      return;
    }
    setLoader(true);
    setLoader(true);
    try {
      const postdata = {
        sell_info: UpdatedCart?.sell_info,
        payment_info: {
          debited_amount: debitedamount,
          pay_data: pay_data,
          balance_due:
            UpdatedCart?.sell_info?.totalamount - UpdatedCart?.totalamount,
          balance_deposit: UpdatedCart?.totalamount,
        },
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        sales_person_name: saleperson?.label,
        pay_layby_data: laybylist
          ? pay_layby_data
          : paystatement === "LayBy"
            ? pay_layby_data
            : [],
        paymentMathod:
          installdivtim?.receive?.length && installcof === true
            ? "Installment"
            : paystatement,
        transaction_date: TransactionDate,
        order_type: UpdatedCart?.ordertype
          ? UpdatedCart?.ordertype
          : UpdatedCart?.sell_info?.status_type
            ? UpdatedCart?.sell_info?.status_type
            : order_type,
        order_id: order_id ? order_id : "",
        order_edit: order_edit,
        // shippingInfo:
        //   parts[3] !== "exchange" &&
        //   parts[3] !== "refund" &&
        //   parts[3] !== "reserve" &&
        //   parts[3] !== "receive" &&
        //   parts[3] !== "reserveproduct"
        //     ? parsedObject
        //     : {},
        shippingInfo: parsedObject,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/EditCustomOrder`);
      if (res.code === 200) {
        setLoader(false);
        setcheckoutdetails(res?.data);
        setShoworder(true);
        localStorage.removeItem("showcheckout");
        clearFaroSessionsAfterCheckout();
      } else {
        setLoader(false);
        error(t("Please Try Again!!"));
        closePinModal();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  // const searchrefnumber = (value) => {
  //   let array = [...UpdatedCart?.oldcredit_note_options];
  //   if (value) {
  //     let searcharray = array.filter(item => item?.Ref_No === value);
  //     setCredit_noteoption(searcharray);
  //   } else {
  //     setCredit_noteoption(array);
  //   }

  // }
  const searchrefnumber1 = async () => {
    let array = [...UpdatedCart?.oldcredit_note_options];
    let checkamt = [...checkcreaditamount];
    let creditnoteids = [...credit_noteids];

    // ---- STEP 1: decorate original list ----
    array = array.map((item) => {
      const selected = item?.gift_card_id
        ? creditnoteids.find((c) => c.gift_card_id === item.gift_card_id)
        : creditnoteids.find((c) => c.id === item.id);

      const used = item?.gift_card_id
        ? checkamt.find((c) => c.gift_card_id === item.gift_card_id)
        : checkamt.find((c) => c.id === item.id);

      if (selected)
        return {
          ...item,
          amount: +selected.amount,
          old_amount: +selected.old_amount,
          classadd: true,
        };

      if (used) {
        const rem = +item.initial_amount - +used.amount;
        return { ...item, amount: rem, old_amount: rem };
      }

      return item;
    });

    // ---- STEP 2: no refNo → return original list ----
    if (!refNo) {
      setCredit_noteoption(array);
      return;
    }

    // ---- STEP 3: Local Search ----
    let localMatch = array.find((item) => item?.Ref_No === refNo);

    if (localMatch) {
      // MOVE FOUND ITEM TO TOP
      const newList = [
        localMatch,
        ...array.filter((item) => item?.Ref_No !== refNo),
      ];

      setCredit_noteoption(newList);
      return;
    }

    // ---- STEP 4: API SEARCH ----
    try {
      let res = await _Api(
        { gift_card_number: refNo },
        `api/v1/POS/checkout/creditnote/getCreditNote`,
      );

      if (res?.code === 200 && res?.data?.length) {
        success(t("Matching Giftcard found"));
        let giftCard = res.data[0];

        const selected = creditnoteids.find(
          (c) =>
            (c.gift_card_id && c.gift_card_id === giftCard.gift_card_id) ||
            c.id === giftCard.id,
        );
        const used = checkamt.find(
          (c) =>
            (c.gift_card_id && c.gift_card_id === giftCard.gift_card_id) ||
            c.id === giftCard.id,
        );

        let newTopItem;

        if (selected) {
          newTopItem = {
            ...giftCard,
            amount: +selected.amount,
            old_amount: +selected.old_amount,
            classadd: true,
          };
        } else if (used) {
          const rem = +giftCard.initial_amount - +used.amount;
          newTopItem = { ...giftCard, amount: rem, old_amount: rem };
        } else {
          newTopItem = giftCard;
        }

        // ---- STEP 5: PREPEND API CARD TO TOP ----
        setCredit_noteoption([newTopItem, ...array]);
        UpdatedCart?.oldcredit_note_options?.push(newTopItem);
        return;
      }

      error(t("No Giftcard with this RefNO"));
      setCredit_noteoption(array);
    } catch (err) {
      error(t("Something went wrong"));
      setCredit_noteoption(array);
    }
  };

  const verfypin = async () => {
    try {
      const postdata = {
        verfypin: otpnumber.join().replace(/,/g, ""),
      };
      let res = await _Api(postdata, `api/v1/POS/common/loginPINVerfy`);
      if (res.code === 200) {
        if (order_edit) {
          editcheckoutorder();
        } else {
          checkoutorder();
        }
      } else {
        error(t("Please Try Again!!"));
        setOtpnumber([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getcurrency = async () => {
    try {
      const postdata = {};
      let res = await _Api(postdata, `api/v1/POS/common/exchange-rates`);
      if (res.code === 200) {
        setCurrencyoption(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    let array = [];
    let arrayIB = [];
    if (UpdatedCart?.payment_Options?.Bank?.length) {
      UpdatedCart?.payment_Options?.Bank.forEach((result) => {
        const bankType = String(result?.BankPaymenttype || "").trim();
        if (bankType === "IB") {
          arrayIB.push({
            label: result?.name,
            value: result?.id,
            PaymentMethod: result?.PaymentMethod,
            PaymentMethodLogo: result?.PayMethod_logo,
            name: result?.name,
            payment_slag: result?.payment_slag,
          });
        } else if (bankType === "Cheque") {
          array.push({
            label: result?.name,
            value: result?.id,
            PaymentMethodLogo: result?.PayMethod_logo,
            name: result?.name,
          });
        }
      });
    }
    setBanknameCheque(array);
    setBanknameIB(arrayIB);
  }, [UpdatedCart?.payment_Options?.Bank]);
  useEffect(() => {
    if (
      generalsettings?.data?.generalsetup?.Users_to_enter_PIN_for_every_sale ===
      "1"
    ) {
      if (otpnumber?.length === 6) {
        verfypin();
      }
    }
    // eslint-disable-next-line
  }, [otpnumber, generalsettings]);
  useEffect(() => {
    getcurrency();
  }, []);
  useEffect(() => {
    setCalnumbers("");
    setExchange("");
    setrepaymentids("");
    setChnagecurrencies(posloc?.curr);
    setRechangekey("");
  }, [mode, posloc?.curr]);
  useEffect(() => {
    if (installdivtim?.installment?.value && installdivtim?.term?.value) {
      callinstallment();
    }
    // eslint-disable-next-line
  }, [
    installdivtim?.installment?.value,
    installdivtim?.term?.value,
    balancedue,
  ]);

  // IB Payment System CODE START
  const [selectedImage, setSelectedImage] = useState(null);
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Preview the image
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage({ file, preview: imageUrl });

    try {
      // Read file as Base64
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64Data = e.target.result;
        const filenameWithoutExt = file.name.split(".")[0];

        // Send base64 to backend
        const response = await _Api(
          JSON.stringify({ image: base64Data, filename: filenameWithoutExt }),
          "api/v1/POS/checkout/payment/saveBankPaymentsImage",
        );

        if (response.code === 200) {
          if (!inputActive) {
            setBankDetails((existing) => ({
              ...existing,
              paymentAttchment: response?.data?.image,
            }));
          } else {
            setPayImage(response?.data?.image);
          }
        } else {
          error(t("Please Try Again!!"));
        }
      };

      reader.readAsDataURL(file);
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };
  const handleSavePayImage = (index, type) => {
    if (index < 0) return;

    if (type === "ib") {
      setPay_data((prev) => ({
        ...prev,
        IB: prev.IB.map((item, i) =>
          i === index ? { ...item, paymentAttchment: payImage } : item,
        ),
      }));
    } else {
      setPay_data((prev) => ({
        ...prev,
        bank: prev.bank.map((item, i) =>
          i === index ? { ...item, paymentAttchment: payImage } : item,
        ),
      }));
    }
    setPayImage();
    setSelectedImage();
    if (type === "ib") setActivelist((prev) => ({ ...prev, ib: false }));
    else setActivelist((prev) => ({ ...prev, bank: false }));
  };

  const handleDivClick = () => {
    document.getElementById("fileInput").click();
  };
  const handleDivClick1 = () => {
    document.getElementById("fileInput1").click();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrCodeImage, setQrCodeImage] = useState(null);
  const [qrCodeMessage, setQrCodeMessage] = useState("Loading QR Code...");

  const [countdown, setCountdown] = useState(100); // 5 minutes in seconds
  // const [paymentStatus, setPaymentStatus] = useState("Pending");
  const [qrCodePaymentId, setQrCodePaymentId] = useState({
    value: "",
    PaymentMethod: "",
  });
  const [qrCodeTractionsId, setQrCodeTractionsId] = useState("");
  const timerIdRef = useRef(null);
  const generateQRCode = async () => {
    try {
      // API call to generate QR Code

      if (!qrCodePaymentId?.PaymentMethod) {
        error(t("Please select bank"));
        return false;
      }
      if (!calnumbers) {
        error(t("Please enter amount"));
        return false;
      }
      const postdata = {
        payment_id: qrCodePaymentId?.PaymentMethod,
        amount: calnumbers,
        customerId: customer?.id,
      };

      let response = await _Api(
        postdata,
        `api/v1/POS/PaymentQRcode/generateQRcode`,
      );
      if (response.code === 200) {
        setQrCodeImage(response.data.qrCode);
        setQrCodeTractionsId(response.data.client_reference_id);
        setIsModalOpen(true);
      } else {
        setQrCodeImage("");
        setQrCodeTractionsId("");
        setIsModalOpen(true);
        setQrCodeMessage(response.message);
        // error(t("Please Try Again!!"));
      }
    } catch (error) {
      console.error("Error generating QR Code:", error);
      alert("Failed to generate QR Code. Please try again.");
    }
  };

  const checkPaymentStatus = async () => {
    try {
      if (!qrCodeTractionsId) {
        return false;
      }

      const postdata = {
        transactionId: qrCodeTractionsId,
        payment_slag: qrCodePaymentId?.payment_slag,
      };
      let response = await _Api(
        postdata,
        `api/v1/POS/PaymentQRcode/getPaymentStatus`,
      );
      if (response.code === 200) {
        if (response.data && response.data.payment_status) {
          if (response.data.payment_success === true) {
            clearInterval(timerIdRef.current);
            success(t("Payment successful!"));
            setIsModalOpen(false);
            setCountdown(100);
            let transID =
              qrCodePaymentId?.payment_slag === "paypal-payment" ||
              qrCodePaymentId?.payment_slag === "cregis-payment"
                ? response.data.transactionID || response.data.cregis_id
                : response.data.payment_intent_id;
            debitedprice(transID); // this is a  Sub button click
          }
        }
      } else {
        error(t("Please Try Again!!"));
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
    }
  };

  const QrCodeCancelHendal = async () => {
    try {
      setCountdown(100);
      if (!qrCodeTractionsId) {
        return false;
      }
      const postdata = { client_reference_id: qrCodeTractionsId };
      let response = await _Api(
        postdata,
        `api/v1/POS/PaymentQRcode/cancelQRcode`,
      );
      if (response.code === 200) {
        setCountdown(100);
      } else {
        error(t("Please Try Again!!"));
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      // Countdown timer
      timerIdRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timerIdRef.current); // Clear timer when countdown ends

            error("Payment timeout. Please try again.");
            setCountdown(100);
            setIsModalOpen(false);
            return 0;
          }
          return prev - 1;
        });
        // Periodically check payment status
        checkPaymentStatus();
      }, 5000);
    }

    return () => {
      clearInterval(timerIdRef.current); // Clear timer on component unmount
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  const onPaymentSuccess = (transID, status, paidAmount, cryptoMeta = {}) => {
    debitedprice(transID, status, paidAmount, cryptoMeta);
  };
  const handleAddmoreIBClick = () => {
    setActivelist((prev) => ({ ...prev, ib: true }));
    if (banknameIB && banknameIB.length > 0) {
      const firstOption = banknameIB[0];
      setQrCodePaymentId({
        value: firstOption.value,
        PaymentMethod: firstOption.PaymentMethod,
        PaymentMethodLogo: firstOption.PaymentMethodLogo,
        name: firstOption?.name,
        payment_slag: firstOption?.payment_slag,
      });
      // generateQRCode();
    } else {
      setQrCodePaymentId({
        value: "",
        PaymentMethod: "",
      });
    }
    setInputActive(false);
    setCalnumbers("");
  };
  const handleAddmoreBankClick = () => {
    setActivelist((prev) => ({ ...prev, bank: true }));
    setBankDetails({
      transcation_date: new Date(),
      payment_method_id: "",
      ac_no: "",
      ac_name: "",
      ref_no: "",
      inst_no: "",
      amount: "",
      Paymentmethod_type: "",
      payment_slag: "",
    });
    setInputActive(false);
    setCalnumbers("");
  };
  const handleIBEditClick = (index, id) => {
    setActivelist((prev) => ({ ...prev, ib: true }));
    setIndex(index);
    let item = pay_data?.IB?.[index];
    setQrCodePaymentId({
      value: item.payment_method_id,
      PaymentMethod: item.PaymentMethod,
      PaymentMethodLogo: item.PaymentMethodLogo,
      name: item.name,
      payment_slag: item.payment_slag,
    });
    setInputActive(true);
    setCalnumbers(item.amount);
  };
  const handleBankEditClick = (index, id) => {
    setActivelist((prev) => ({ ...prev, bank: true }));
    setIndex(index);
    let item = pay_data?.bank?.[index];
    setBankDetails(item);
    setInputActive(true);
    setCalnumbers(item.amount);
  };

  const hasBankMethods = Boolean(UpdatedCart?.payment_Options?.Bank?.length);
  const hasCreditCardMethods = Boolean(
    UpdatedCart?.payment_Options?.Credit_Card?.length
  );
  const hasIBMethods = Boolean(banknameIB?.length);
  const hasChequeMethods = Boolean(banknameCheque?.length);
  const openBankPaymentTab = () => {
    if (!hasBankMethods) return;
    setInputActive(false);
    if (hasIBMethods) {
      setMode("bankib");
      if (pay_data?.IB?.length) {
        setActivelist((prev) => ({ ...prev, ib: false }));
      }
    } else if (hasChequeMethods) {
      setMode("bankcheque");
      if (pay_data?.bank?.length) {
        setActivelist((prev) => ({ ...prev, bank: false }));
      }
    }
  };

  return (
    <>
      <div className="main-body-row-right-col-inner">
        <div className="main-body-row-right-col-inner-ct-top">
          <div className="main-body-row-right-col-inner-ct-top-inner">
            <div className="main-body-row-right-col-inner-ct-top-inner-date-area">
              <div className="main-body-row-right-col-inner-ct-top-inner-date-area-inner">
                <span>
                  {UpdatedCart?.sell_info?.status_type === "custom_order" ||
                  UpdatedCart?.sell_info?.status_type === "mix_and_match"
                    ? "CO-XXX"
                    : UpdatedCart?.sell_info?.status_type === "pos_order"
                      ? "POS-XXX"
                      : "XXXX"}
                </span>{" "}
                :
                <div className="main-body-row-right-col-inner-ct-top-inner-date-area-inner-input date">
                  <DatePicker
                    className="date-field"
                    selected={TransactionDate}
                    onChange={(input) => setTransactionDate(input)}
                    name="TransactionDate"
                    dateFormat={OrgSettings?.date_picker}
                    autoComplete="none"
                    popperPlacement="top-start"
                  />
                  <img
                    className="date-img"
                    src={base_assets + "images/icons/calendar-green.svg"}
                    alt=""
                  />
                </div>
              </div>
              <div className="main-body-row-right-col-inner-ct-top-inner-date-area-select">
                <Saleperson />
              </div>
            </div>
            <div className="main-body-row-right-col-inner-ct-top-inner-search">
              <CustomerSearchModal setCusid={setCusid}></CustomerSearchModal>
              {parmissiondatashow?.pos_customer_reports?.Add ? (
                <span className="main-body-row-right-col-inner-ct-top-inner-search-user">
                  <img
                    data-bs-toggle="modal"
                    data-bs-target="#customerAddModal"
                    src={base_assets + "images/pos/icons/add-user.png"}
                    alt=""
                  />
                </span>
              ) : (
                ""
              )}
              {customer?.id ? (
                <span
                  className={
                    parts[3] !== "exchange" &&
                    parts[3] !== "refund" &&
                    parts[3] !== "reserve" &&
                    parts[3] !== "receive" &&
                    parts[3] !== "reserveproduct"
                      ? "main-body-row-right-col-inner-ct-top-inner-search-user"
                      : "d-none"
                  }
                  onClick={() => {
                    setToggleAddressCustomer(!toggleAddressCustomer);
                  }}
                >
                  {customer?.existsInAddress ? (
                    <img src={addressicon} alt="" />
                  ) : (
                    <img
                      className="iconwithnotification"
                      src={notaddressicon}
                      alt=""
                    />
                  )}
                </span>
              ) : (
                <span
                  className={
                    parts[3] !== "exchange" &&
                    parts[3] !== "refund" &&
                    parts[3] !== "reserve" &&
                    parts[3] !== "receive" &&
                    parts[3] !== "reserveproduct"
                      ? "main-body-row-right-col-inner-ct-top-inner-search-user"
                      : "d-none"
                  }
                  onClick={() => {
                    error(t("Customer is Requried!!"));
                  }}
                >
                  <img src={addressicon} alt="" />
                </span>
              )}
            </div>
          </div>
        </div>
        {toggleAddressCustomer && customer?.id ? (
          <AddCustomerAddressPopup />
        ) : (
          <div className="main-body-row-right-col-inner-progress">
            <div className="main-body-row-right-col-inner-progress-line">
              <div className="main-body-row-right-col-inner-progress-line-single col active"></div>
              <div className="main-body-row-right-col-inner-progress-line-single col active"></div>
              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
            </div>

            <div className="main-body-row-right-col-inner-progress-step">
              {UpdatedCart?.receivestatus === "receivepay" ? (
                <div className="main-body-row-right-col-inner-progress-step-single active">
                  <div className="main-body-row-right-col-inner-progress-step-single-circle">
                    <img
                      src={base_assets + "images/pos/icons/right-icon.png"}
                      alt=""
                    />
                  </div>
                  <span className="main-body-row-right-col-inner-progress-step-single-text">
                    {t("sell")}
                  </span>
                </div>
              ) : (
                <div
                  className="main-body-row-right-col-inner-progress-step-single active"
                  onClick={() => setShowcheckout("sell")}
                >
                  <div className="main-body-row-right-col-inner-progress-step-single-circle">
                    <img
                      src={base_assets + "images/pos/icons/right-icon.png"}
                      alt=""
                    />
                  </div>
                  <span className="main-body-row-right-col-inner-progress-step-single-text">
                    {t("sell")}
                  </span>
                </div>
              )}

              <div className="main-body-row-right-col-inner-progress-step-single second active">
                <div className="main-body-row-right-col-inner-progress-step-single-circle">
                  {showorder ? (
                    <img
                      src={base_assets + "images/pos/icons/right-icon.png"}
                      alt=""
                    />
                  ) : (
                    <span className="main-body-row-right-col-inner-progress-step-single-circle-dot"></span>
                  )}
                </div>
                <span className="main-body-row-right-col-inner-progress-step-single-text">
                  {t("Payment")}
                </span>
              </div>
              <div
                className={
                  showorder
                    ? "main-body-row-right-col-inner-progress-step-single active"
                    : "main-body-row-right-col-inner-progress-step-single"
                }
              >
                <div className="main-body-row-right-col-inner-progress-step-single-circle">
                  {showorder ? (
                    <img
                      src={base_assets + "images/pos/icons/right-icon.png"}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </div>
                <span className="main-body-row-right-col-inner-progress-step-single-text">
                  {t("done")}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* <div className='main-body-row-right-col-inner-payment-balance'>
          <div className='main-body-row-right-col-inner-payment-balance-box total'>
            <span className='main-body-row-right-col-inner-payment-balance-box-text'>{UpdatedCart?.sell_info?.status_type === 'pos_order' || UpdatedCart?.sell_info?.status_type === 'gift_card_order' ? t('Grand Total') : t("Deposit Amount")} :</span>
            <span className='main-body-row-right-col-inner-payment-balance-box-price'>{toFormatPrice(UpdatedCart?.totalamount, { addSymbol: true })}</span>
          </div>
          <div className='main-body-row-right-col-inner-payment-balance-box danger-text'>
            <span className='main-body-row-right-col-inner-payment-balance-box-text'>{t("Balance due")} :</span>
            <span className='main-body-row-right-col-inner-payment-balance-box-price'>{toFormatPrice(balancedue, { addSymbol: true })}</span>

          </div>
        </div> */}
        {UpdatedCart?.ordertype === "pos_order" ? (
          <ul
            className={
              UpdatedCart?.ordertype === "refund_order"
                ? "main-body-row-right-col-inner-payment-layby-area nav nav-tabs pe-none"
                : "main-body-row-right-col-inner-payment-layby-area nav nav-tabs"
            }
          >
            <li
              className="nav-item main-body-row-right-col-inner-payment-layby-area-tab active "
              onClick={() => setPaystatement("Full_Payment")}
            >
              <span className="nav-link active" data-bs-toggle="tab">
                {t("Full Payment")}
              </span>
            </li>
            <li
              className={
                generalsettings?.data?.generalsetup?.POS_partial_payment === "1"
                  ? "nav-item main-body-row-right-col-inner-payment-layby-area-tab "
                  : "d-none"
              }
              onClick={() => setPaystatement("LayBy")}
            >
              <span className="nav-link" data-bs-toggle="tab">
                {t("Layby")}
              </span>
            </li>
            <li
              onClick={() => {
                UpdatedCart?.installmentarray?.length
                  ? setInstallementdata(UpdatedCart?.installmentarray)
                  : setinstalldivtim((existing) => ({
                      ...existing,
                      installment: { label: 10, value: 10 },
                    }));
              }}
              className={
                generalsettings?.data?.generalsetup?.POS_partial_payment ===
                  "1" &&
                !(
                  debitedamount?.cash ||
                  debitedamount?.bank ||
                  debitedamount?.credit_card ||
                  debitedamount?.credit_notes
                )
                  ? "nav-item main-body-row-right-col-inner-payment-layby-area-tab"
                  : "d-none"
              }
              data-bs-toggle="modal"
              data-bs-target="#installmentModal"
            >
              <span className="nav-link" data-bs-toggle="tab">
                {t("Installment")}
              </span>
            </li>
          </ul>
        ) : UpdatedCart?.installmentarray?.length ? (
          <ul className="main-body-row-right-col-inner-payment-layby-area nav nav-tabs">
            <li
              onClick={() => {
                UpdatedCart?.installmentarray?.length
                  ? setInstallementdata(UpdatedCart?.installmentarray)
                  : callinstallment();
              }}
              className={
                !(
                  debitedamount?.cash ||
                  debitedamount?.bank ||
                  debitedamount?.credit_card ||
                  debitedamount?.credit_notes
                )
                  ? "nav-item main-body-row-right-col-inner-payment-layby-area-tab"
                  : "d-none"
              }
              data-bs-toggle="modal"
              data-bs-target="#installmentModal"
            >
              <span className="nav-link" data-bs-toggle="tab">
                {t("Installment")}
              </span>
            </li>
          </ul>
        ) : UpdatedCart?.sell_info?.status_type === "lay_by" ? (
          <ul className="main-body-row-right-col-inner-payment-layby-area nav nav-tabs">
            <li
              className={
                generalsettings?.data?.generalsetup?.POS_partial_payment === "1"
                  ? "nav-item main-body-row-right-col-inner-payment-layby-area-tab "
                  : "d-none"
              }
              onClick={() => setPaystatement("LayBy")}
            >
              <span className="nav-link" data-bs-toggle="tab">
                {t("Layby")}
              </span>
            </li>
          </ul>
        ) : (
          ""
        )}
        <div className="main-body-row-right-col-inner-payment box-3">
          <div className="tab-calc-wrap d-flex flex flex-column justify-content-between h-100">
            <div className="main-body-row-right-col-inner-payment-tabs">
              <ul
                className={
                  UpdatedCart?.ordertype === "refund_order"
                    ? "nav nav-tabs event-none"
                    : "nav nav-tabs"
                }
              >
                <li className="nav-item cashtab">
                  <a
                    className="nav-link active cash"
                    onClick={() => {
                      setMode("cash");
                      setInputActive(false);
                      setActivelist({ ib: true, bank: true });
                    }}
                    data-bs-toggle="tab"
                    href="#cash"
                  >
                    <span className="nav-link-img">
                      <img
                        className="not-active"
                        src={base_assets + "images/pos/icons/cash-icon.png"}
                        alt=""
                      />
                      <img
                        className="active"
                        src={base_assets + "images/pos/icons/cash-icon-g.png"}
                        alt=""
                      />
                    </span>
                    {t("Cash")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link card${
                      !hasCreditCardMethods ? " pe-none opacity-50" : ""
                    }`}
                    data-bs-toggle={hasCreditCardMethods ? "tab" : undefined}
                    onClick={(e) => {
                      if (!hasCreditCardMethods) {
                        e.preventDefault();
                        return;
                      }
                      setMode("credit-card");
                      setActivelist({ ib: true, bank: true });
                    }}
                    href={hasCreditCardMethods ? "#credit-card" : undefined}
                    aria-disabled={!hasCreditCardMethods}
                  >
                    <span className="nav-link-img">
                      <img
                        className="not-active"
                        src={base_assets + "images/pos/icons/card.png"}
                        alt=""
                      />
                      <img
                        className="active"
                        src={base_assets + "images/pos/icons/card-g.png"}
                        alt=""
                      />
                    </span>
                    {t("Credit Card")}
                  </a>
                </li>
                <li className="nav-item bank-tabs">
                  <a
                    className={`nav-link bank${
                      !hasBankMethods ? " pe-none opacity-50" : ""
                    }`}
                    data-bs-toggle={hasBankMethods ? "tab" : undefined}
                    href={hasBankMethods ? "#bank" : undefined}
                    onClick={(e) => {
                      if (!hasBankMethods) {
                        e.preventDefault();
                        return;
                      }
                      openBankPaymentTab();
                    }}
                    aria-disabled={!hasBankMethods}
                  >
                    <span className="nav-link-img">
                      <img
                        className="not-active"
                        src={base_assets + "images/pos/icons/bank.png"}
                        alt=""
                      />
                      <img
                        className="active"
                        src={base_assets + "images/pos/icons/bank-g.png"}
                        alt=""
                      />
                    </span>
                    {t("Bank")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link note"
                    data-bs-toggle="tab"
                    href="#credit-note"
                    onClick={() => {
                      setMode("credit-note");
                      setInputActive(false);
                      setActivelist({ ib: true, bank: true });
                    }}
                  >
                    <span className="nav-link-img">
                      <img
                        className="not-active"
                        src={base_assets + "images/pos/icons/credit-note.png"}
                        alt=""
                      />
                      <img
                        className="active"
                        src={base_assets + "images/pos/icons/credit-note-g.png"}
                        alt=""
                      />
                    </span>
                    {t("Credit Note")}
                  </a>
                  {credit_noteoption?.length ? (
                    <img
                      className="comment-icon"
                      src={base_assets + "images/pos/icons/comment-icon.png"}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </li>
              </ul>
              {!toggleAddressCustomer && (
                <div className="tab-content">
                  <div
                    className="tab-pane container active main-body-row-right-col-inner-payment-tabs-cash"
                    id="cash"
                  >
                    <div className="main-body-row-right-col-inner-payment-tabs-cash-ul">
                      <div className="dropdown common-dropdown">
                        <div
                          className="main-body-row-right-col-inner-payment-tabs-cash-ul-li"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="main-body-row-right-col-inner-payment-tabs-cash-ul-li-img">
                            {chnagecurrencies ? (
                              <img
                                className="active"
                                src={
                                  base_assets +
                                  "images/flags/" +
                                  chnagecurrencies.toLowerCase() +
                                  ".png"
                                }
                                alt=""
                              />
                            ) : (
                              <img
                                className="active"
                                src={
                                  base_assets +
                                  "images/flags/" +
                                  posloc?.curr.toLowerCase() +
                                  ".png"
                                }
                                alt=""
                              />
                            )}
                          </span>
                          <label>
                            {chnagecurrencies
                              ? chnagecurrencies
                              : posloc?.curr
                                ? posloc?.curr
                                : ""}
                          </label>
                        </div>
                        <ul className="dropdown-menu">
                          {Currencyoption?.length
                            ? Currencyoption.map((result, curkey) => {
                                return (
                                  <li key={curkey}>
                                    <span
                                      className="dropdown-item"
                                      onClick={() => {
                                        const paidRate = safeRateForDivision(
                                          result?.rate,
                                        );
                                        const storeRate = safeRateForDivision(
                                          getCurrencyRate(posloc?.curr, 1),
                                        );
                                        const equivalentRate =
                                          paidRate / storeRate;
                                        setChnagecurrencies(result?.currency);
                                        setExchange(
                                          Number(equivalentRate.toFixed(6)),
                                        );
                                      }}
                                    >
                                      {result?.currency ? (
                                        <img
                                          className="active"
                                          src={
                                            base_assets +
                                            "images/flags/" +
                                            result?.flag
                                          }
                                          alt=""
                                        />
                                      ) : (
                                        ""
                                      )}
                                      {result?.currency}
                                    </span>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                      {chnagecurrencies !== posloc?.curr &&
                      chnagecurrencies !== undefined ? (
                        <div className="placeholder-up-input">
                          <span>{t("Exchange rate")}</span>
                          <input
                            type="text"
                            className="placeholder-up-input-field"
                            value={exchange}
                            onChange={(e) => setExchange(e.target.value)}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {chnagecurrencies !== posloc?.curr &&
                    chnagecurrencies !== undefined ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        <span
                          style={{
                            color: "#606060",
                            fontSize: 12,
                            fontFamily: "Segoe UI",
                          }}
                        >
                          {`Collect in ${chnagecurrencies || ""}: ${toFormatPrice(
                            computeRequiredCashToCollect(balancedue, exchange),
                            { addSymbol: false },
                          )} ${chnagecurrencies || ""}`}
                        </span>
                        <span className="main-body-row-right-col-inner-payment-tabs-cash-exchange-rate">
                          ={" "}
                          {mode === "cash" &&
                          exchange !== "" &&
                          calnumbers !== ""
                            ? toFormatPrice(
                                computeCashInStoreCurrency(
                                  calnumbers,
                                  exchange,
                                ),
                                {
                                  addSymbol: true,
                                },
                              )
                            : "0.00"}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    <ViewPaymentLogsModel
                      transcationcounts={transcationcounts}
                      pay_data={pay_data}
                      mode={mode}
                    />
                  </div>

                  <div
                    className="tab-pane container fade main-body-row-right-col-inner-payment-tabs-card"
                    id="credit-card"
                  >
                    <div
                      className={
                        isActive
                          ? "d-none"
                          : "main-body-row-right-col-inner-payment-tabs-card-inner"
                      }
                    >
                      <div className="main-body-row-right-col-inner-payment-calculator-value">
                        <input
                          className={
                            mode === "credit-card" &&
                            repaymentids === "creditcardview"
                              ? "main-body-row-right-col-inner-payment-calculator-value-input pointer-none"
                              : "main-body-row-right-col-inner-payment-calculator-value-input"
                          }
                          pattern="[0.0-9]*"
                          value={calnumbers}
                          onKeyDown={(e) => callnumber(e.key)}
                          placeholder={t("enter amount")}
                        />
                        <button
                          className="main-body-row-right-col-inner-payment-calculator-value-clear btn"
                          onClick={() => setCalnumbers(calnumbers.slice(0, -1))}
                        >
                          <img
                            className="active"
                            src={base_assets + "images/pos/icons/clear-btn.png"}
                            alt=""
                          />
                        </button>
                      </div>

                      {UpdatedCart?.payment_Options?.Credit_Card?.length
                        ? UpdatedCart?.payment_Options?.Credit_Card.map(
                            (result, creditkey) => {
                              return (
                                <div
                                  className="main-body-row-right-col-inner-payment-tabs-card-inner-li"
                                  key={creditkey}
                                  onClick={() => {
                                    creditCard();
                                    setcreditCardDetails((existing) => ({
                                      ...existing,
                                      name: result?.name,
                                      logo: result?.PayMethod_logo,
                                      payment_method_id: result?.id,
                                      PaymentMethod: result?.PaymentMethod,
                                    }));
                                    setcreditCardDetails((existing) => ({
                                      ...existing,
                                      Paymentmethod_type:
                                        result?.Paymentmethod_type,
                                      payment_slag: resolveGatewaySlag(result),
                                      key: result?.key,
                                    }));
                                  }}
                                >
                                  <img src={result?.PayMethod_logo} alt="" />
                                  <span className="main-body-row-right-col-inner-payment-tabs-card-inner-li-text">
                                    {result?.name}
                                  </span>
                                </div>
                              );
                            },
                          )
                        : ""}
                    </div>
                    <div
                      className={
                        isActive
                          ? "main-body-row-right-col-inner-payment-tabs-card-single-detail"
                          : "d-none"
                      }
                    >
                      <div className="main-body-row-right-col-inner-payment-tabs-card-single-detail-head">
                        <button
                          className="back btn-style"
                          onClick={() => {
                            creditCard();
                            setcreditCardDetails({
                              name: "",
                              logo: "",
                              card_name: "",
                              card_number: "",
                              payment_method_id: "",
                              amount: "",
                              Paymentmethod_type: "",
                              payment_slag: "",
                            });
                          }}
                        >
                          <img
                            className="active"
                            src={
                              base_assets +
                              "images/pos/icons/arrow-gray-left.png"
                            }
                            alt=""
                          />
                        </button>
                        <h4 className="main-body-row-right-col-inner-payment-tabs-card-single-detail-head-text">
                          <img src={creditCardDetails?.logo} alt="" />
                          <label>{creditCardDetails?.name}</label>
                        </h4>
                      </div>
                      {creditCardDetails?.payment_slag === "stripe-payment" ? (
                        <StripeCheckout
                          customer_id={customer?.id}
                          creditCardDetails={creditCardDetails}
                          setcreditCardDetails={setcreditCardDetails}
                          amount={calnumbers}
                          onPaymentSuccess={onPaymentSuccess}
                        />
                      ) : creditCardDetails?.payment_slag === "cregis-payment" ? (
                        Number(calnumbers) > 0 && isActive ? (
                          <CregisPayment
                            customer_id={customer?.id}
                            amount={Number(calnumbers)}
                            paymentDetails={creditCardDetails}
                            onPaymentSuccess={onPaymentSuccess}
                          />
                        ) : null
                      ) : creditCardDetails?.payment_slag === "paypal-payment" ? (
                        <>
                          {Number(calnumbers) > 0 && isActive && (
                            <PayPalButton
                              currency={OrgSettings?.price_format?.currency}
                              customer_id={customer?.id}
                              creditCardDetails={creditCardDetails}
                              setcreditCardDetails={setcreditCardDetails}
                              amount={Number(calnumbers)}
                              onPaymentSuccess={onPaymentSuccess}
                            />
                          )}
                        </>
                      ) : null}
                    </div>
                    {!isActive ? (
                      <>
                        {/* <div className='dots'>
                        {
                          [...Array(transcationcounts?.credit_card)].map((dckry, dckrys) => {
                            return (<span key={dckrys} onClick={() => reCreditCardPayment(dckrys)} className={Rechangekey === dckrys && Rechangekey !== undefined ? 'dots-single active' : 'dots-single'}></span>);
                          })
                        }
                      </div> */}
                        <ViewPaymentLogsModel
                          transcationcounts={transcationcounts}
                          pay_data={pay_data}
                          mode={mode}
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="tab-pane container fade main-body-row-right-col-inner-payment-tabs-card-bank"
                    id="bank"
                  >
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <a
                          className={`nav-link${
                            hasIBMethods ? " active" : ""
                          }${!hasIBMethods ? " pe-none opacity-50" : ""}`}
                          data-bs-toggle={hasIBMethods ? "tab" : undefined}
                          href={hasIBMethods ? "#banking" : undefined}
                          onClick={(e) => {
                            if (!hasIBMethods) {
                              e.preventDefault();
                              return;
                            }
                            setMode("bankib");
                            setInputActive(false);
                            if (pay_data?.IB?.length) {
                              setActivelist((prev) => ({ ...prev, ib: false }));
                            }
                          }}
                          aria-disabled={!hasIBMethods}
                        >
                          {t("Internet Banking")}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link${
                            !hasIBMethods && hasChequeMethods ? " active" : ""
                          }${!hasChequeMethods ? " pe-none opacity-50" : ""}`}
                          data-bs-toggle={hasChequeMethods ? "tab" : undefined}
                          onClick={(e) => {
                            if (!hasChequeMethods) {
                              e.preventDefault();
                              return;
                            }
                            setMode("bankcheque");
                            setInputActive(false);
                            if (pay_data?.bank?.length) {
                              setActivelist((prev) => ({
                                ...prev,
                                bank: false,
                              }));
                            }
                          }}
                          href={hasChequeMethods ? "#cheque" : undefined}
                          aria-disabled={!hasChequeMethods}
                        >
                          {t("Cheque")}
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div
                        className={`tab-pane container${
                          hasIBMethods ? " active" : " fade"
                        }`}
                        id="banking"
                      >
                        {activelist.ib === true ? (
                          <>
                            <span className="bankspan">
                              {t("Select your bank")}
                            </span>
                            <Select
                              className="Select"
                              placeholder=""
                              options={banknameIB}
                              value={banknameIB.find(
                                (opt) => opt.value === qrCodePaymentId?.value,
                              )} // ← controls selected item
                              components={{
                                ValueContainer: CustomValueContainer,
                              }}
                              classNamePrefix="common-select1"
                              onChange={(e) => {
                                setQrCodePaymentId({
                                  value: e.value,
                                  PaymentMethod: e.PaymentMethod,
                                  PaymentMethodLogo: e.PaymentMethodLogo || "",
                                  name: e.name,
                                  payment_slag: e?.payment_slag,
                                });
                                // generateQRCode(e.value,e.PaymentMethod);
                                // setQrCodeImage(null);
                              }}
                              getOptionLabel={(e) => (
                                <div className="">{e.label}</div>
                              )}
                              isSearchable={false}
                              isDisabled={inputActive}
                            />
                            {qrCodePaymentId?.payment_slag === "cregis-payment" ? (
                              <CregisPayment
                                customer_id={customer?.id}
                                amount={Number(calnumbers)}
                                paymentDetails={{
                                  ...qrCodePaymentId,
                                  payment_method_id: qrCodePaymentId?.value,
                                }}
                                onPaymentSuccess={(transID, status, paidAmount, cryptoMeta) => {
                                  setQrCodeTractionsId(transID);
                                  onPaymentSuccess(transID, status, paidAmount, cryptoMeta);
                                }}
                              />
                            ) : null}
                            {/* <div >
                     
                                                   {qrCodeImage ? (
                                                     <img
                                                       src={`${qrCodeImage}`}
                                                       alt="QR Code"
                                                       style={{ width: "200px", height: "200px" }}
                                                     />
                                                   ) : (
                                                     <p>{qrCodeMessage}</p>
                                                   )}
                                             </div> */}

                            {qrCodePaymentId?.payment_slag !== "cregis-payment" ? (
                            <div className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row">
                              <div
                                className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row-btn"
                                onClick={handleDivClick}
                                style={{
                                  cursor: "pointer",
                                  border: "1px solid #ccc",
                                  padding: "10px",
                                }}
                              >
                                <input
                                  id="fileInput"
                                  type="file"
                                  accept="image/*"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleImageChange(e)}
                                />
                                {selectedImage ? (
                                  <img
                                    src={selectedImage.preview}
                                    alt="Selected"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={
                                      base_assets +
                                      "images/pos/icons/camera-icon.png"
                                    }
                                    alt="Camera Icon"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                )}
                                <span>{t("Take a Photo")}</span>
                              </div>

                              <span className="or">{t("or")}</span>
                              {/* QR Code Payment Button */}
                              <div
                                className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row-btn"
                                onClick={generateQRCode}
                                style={{
                                  cursor: "pointer",
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  pointerEvents: inputActive ? "none" : "auto",
                                  opacity: inputActive ? 0.5 : 1,
                                }}
                              >
                                <img
                                  src={
                                    base_assets + "images/pos/icons/qr-icon.png"
                                  }
                                  alt="QR Icon"
                                  style={{ width: "30px", height: "30px" }}
                                />
                                <span>{"Scan QR Code"}</span>
                              </div>

                              {/* QR Code Modal */}
                              {isModalOpen && (
                                <div className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row-QrcodeModel">
                                  <p className="QrcodeModel-heading">
                                    {t("Scan the QR Code")}
                                  </p>
                                  {qrCodeImage ? (
                                    <img
                                      src={`${qrCodeImage}`}
                                      alt="QR Code"
                                      style={{
                                        width: "200px",
                                        height: "200px",
                                      }}
                                    />
                                  ) : (
                                    <p>{qrCodeMessage}</p>
                                  )}
                                  <p className="QrcodeModel-remainingTime">
                                    {t("Time remaining")}:{" "}
                                    {Math.floor(countdown / 60)}:
                                    {String(countdown % 60).padStart(2, "0")}
                                  </p>

                                  <button
                                    className="QrcodeModel-cancel-btn"
                                    onClick={() => {
                                      setIsModalOpen(false);
                                      QrCodeCancelHendal(false);
                                    }}
                                  >
                                    {t("Cancel")}
                                  </button>
                                </div>
                              )}
                            </div>
                            ) : null}
                            {inputActive ? (
                              <button
                                className={`savebtn ${
                                  !payImage ? "disabled" : ""
                                }`}
                                onClick={() => handleSavePayImage(Index, "ib")}
                              >
                                <img
                                  src={SaveBtn}
                                  alt="savebtn"
                                  className="icon default"
                                  style={{ padding: "2px" }}
                                />
                                <img
                                  src={SaveBtnHover}
                                  alt="savebtn-hover"
                                  className="icon hover"
                                />
                              </button>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <>
                            <div
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              <button
                                onClick={() => handleAddmoreIBClick()}
                                style={{
                                  border: "none",
                                  background: "none",
                                  color: "#5FBEAA",
                                }}
                              >
                                <img
                                  style={{ marginRight: "0.2vw" }}
                                  src={Addmorebtnimg}
                                  alt="addmorebtn"
                                />
                                {t("Add more")}
                              </button>
                            </div>
                            {pay_data?.IB?.map((item, index) => (
                              <div className="bank-row" key={index}>
                                <div className="bank-details">
                                  <div className="bank-left">
                                    <img
                                      src={item.PaymentMethodLogo}
                                      alt={item.name}
                                      className="bank-logo"
                                    />
                                    <span className="bank-name">
                                      {item.name}
                                    </span>
                                    {item.paymentAttchment ? (
                                      <img src={ImageUploaded} alt="image" />
                                    ) : (
                                      ""
                                    )}
                                  </div>

                                  <div className="bank-amount">
                                    {toFormatPrice(item.amount, {
                                      addSymbol: true,
                                    })}
                                  </div>
                                </div>

                                <div className="bank-actions">
                                  {item.paymentAttchment ? (
                                    <img
                                      src={Laptop}
                                      alt="edit"
                                      data-bs-toggle="modal"
                                      onClick={() =>
                                        setModalImage(item.paymentAttchment)
                                      }
                                      data-bs-target="#imagePreviewModal"
                                    />
                                  ) : (
                                    ""
                                  )}
                                  <img
                                    src={UploadCameraimg}
                                    alt="camera"
                                    onClick={() => handleIBEditClick(index)}
                                  />
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      <div
                        className={`tab-pane container${
                          !hasIBMethods && hasChequeMethods
                            ? " active"
                            : " fade"
                        }`}
                        id="cheque"
                      >
                        {activelist.bank === true ? (
                          <>
                            <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row">
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single placeholder-up-input placeholder-up-input-date date">
                                <DatePicker
                                  className="placeholder-up-input-field"
                                  selected={banktransactionDate}
                                  onChange={(update) => {
                                    setBanktransactionDate(update);
                                    setBankDetails((existing) => ({
                                      ...existing,
                                      transcation_date: update,
                                    }));
                                  }}
                                  name="TransactionDate"
                                  dateFormat={OrgSettings?.date_picker}
                                  autoComplete="off"
                                  disabled={inputActive}
                                />
                                <img
                                  className="placeholder-up-input-field-calender"
                                  src={
                                    base_assets +
                                    "images/icons/calendar-green.svg"
                                  }
                                  alt=""
                                />
                                <label className="placeholder-up-input-label">
                                  {t("Transaction Date")}
                                </label>
                              </div>
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single">
                                <div className="placeholder-up-input col ps-0">
                                  <Select
                                    className="Select"
                                    placeholder="Bank Name"
                                    options={banknameCheque}
                                    value={banknameCheque?.find(
                                      (opt) =>
                                        opt.value ===
                                        bankDetails?.payment_method_id,
                                    )}
                                    components={{
                                      ValueContainer: CustomValueContainer,
                                    }}
                                    classNamePrefix="common-select"
                                    onChange={(e) =>
                                      setBankDetails((existing) => ({
                                        ...existing,
                                        payment_method_id: e?.value,
                                      }))
                                    }
                                    getOptionLabel={(e) => (
                                      <div className="">{e.label}</div>
                                    )}
                                    isSearchable={false}
                                    isDisabled={inputActive}
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className={
                                (mode === "bankcheque" || mode === "bankib") &&
                                !(
                                  showCalcPopover &&
                                  (keypadMode === "bankcheque" ||
                                    keypadMode === "bankib")
                                )
                                  ? "main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row"
                                  : "d-none"
                              }
                            >
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single">
                                <div className="placeholder-up-input form-floating">
                                  <input
                                    type="text"
                                    className="placeholder-up-input-field"
                                    value={bankDetails?.ac_no}
                                    onChange={(e) =>
                                      setBankDetails((existing) => ({
                                        ...existing,
                                        ac_no: e.target.value,
                                      }))
                                    }
                                    placeholder=""
                                    disabled={inputActive}
                                  />
                                  <label className="placeholder-up-input-label">
                                    {t("A/c No.")}
                                  </label>
                                </div>
                              </div>
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single">
                                <div className="placeholder-up-input form-floating">
                                  <input
                                    type="text"
                                    className="placeholder-up-input-field"
                                    value={bankDetails?.ac_name}
                                    onChange={(e) =>
                                      setBankDetails((existing) => ({
                                        ...existing,
                                        ac_name: e.target.value,
                                      }))
                                    }
                                    placeholder=""
                                    disabled={inputActive}
                                  />
                                  <label className="placeholder-up-input-label">
                                    {t("A/c Name.")}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className={
                                (mode === "bankcheque" || mode === "bankib") &&
                                !(
                                  showCalcPopover &&
                                  (keypadMode === "bankcheque" ||
                                    keypadMode === "bankib")
                                )
                                  ? "main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row"
                                  : "d-none"
                              }
                            >
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single">
                                <div className="placeholder-up-input form-floating">
                                  <input
                                    type="text"
                                    className="placeholder-up-input-field"
                                    value={bankDetails?.ref_no}
                                    onChange={(e) =>
                                      setBankDetails((existing) => ({
                                        ...existing,
                                        ref_no: e.target.value,
                                      }))
                                    }
                                    placeholder=""
                                    disabled={inputActive}
                                  />
                                  <label className="placeholder-up-input-label">
                                    {t("Ref No.")}
                                  </label>
                                </div>
                              </div>
                              <div className="main-body-row-right-col-inner-payment-tabs-card-bank-cheque-row-single">
                                <div className="placeholder-up-input form-floating">
                                  <input
                                    type="text"
                                    className="placeholder-up-input-field"
                                    value={bankDetails?.inst_no}
                                    onChange={(e) =>
                                      setBankDetails((existing) => ({
                                        ...existing,
                                        inst_no: e.target.value,
                                      }))
                                    }
                                    placeholder=""
                                    disabled={inputActive}
                                  />
                                  <label className="placeholder-up-input-label">
                                    {t("Inst No")}.
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className="inputforcheque1"
                                onClick={handleDivClick1}
                              >
                                <input
                                  id="fileInput1"
                                  type="file"
                                  accept="image/*"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleImageChange(e)}
                                />
                                {selectedImage ? (
                                  <img
                                    src={selectedImage.preview}
                                    alt="Selected"
                                    style={{
                                      width: "1vw",
                                      height: "1vw",
                                    }}
                                  />
                                ) : (
                                  <img src={ChequeImg} alt="ChequeImg" />
                                )}
                              </div>
                              {inputActive ? (
                                <button
                                  className={`savebtn ${!payImage ? "disabled" : ""}`}
                                  onClick={() =>
                                    handleSavePayImage(Index, "bank")
                                  }
                                  disabled={!payImage}
                                  style={{ height: "1.5vw" }}
                                >
                                  <img
                                    src={SaveBtn}
                                    alt="savebtn"
                                    className="icon default"
                                    style={{ padding: "2px" }}
                                  />
                                  <img
                                    src={SaveBtnHover}
                                    alt="savebtn-hover"
                                    className="icon hover"
                                  />
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              <button
                                onClick={() => handleAddmoreBankClick()}
                                style={{
                                  border: "none",
                                  background: "none",
                                  color: "#5FBEAA",
                                }}
                              >
                                <img
                                  style={{ marginRight: "0.2vw" }}
                                  src={Addmorebtnimg}
                                  alt="addmorebtn"
                                />
                                {t("Add more")}
                              </button>
                            </div>
                            {pay_data?.bank?.map((item, index) => (
                              <div className="bank-row" key={index}>
                                <div className="bank-details">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "end",
                                      gap: "0.3vw",
                                    }}
                                  >
                                    <div className="bank-left-cheque">
                                      <span className="bank-name">
                                        {item.inst_no}
                                      </span>
                                      <span className="bank-name">
                                        {item.ac_name} (
                                        <span>{item.ac_no}</span>)
                                      </span>
                                    </div>
                                    {item.paymentAttchment ? (
                                      <img src={ImageUploaded} alt="image1" />
                                    ) : (
                                      ""
                                    )}
                                  </div>

                                  <div className="bank-amount">
                                    {toFormatPrice(item.amount, {
                                      addSymbol: true,
                                    })}
                                  </div>
                                </div>

                                <div className="bank-actions">
                                  {item.paymentAttchment ? (
                                    <img
                                      src={Laptop}
                                      alt="edit"
                                      data-bs-toggle="modal"
                                      onClick={() =>
                                        setModalImage(item.paymentAttchment)
                                      }
                                      data-bs-target="#imagePreviewModal"
                                    />
                                  ) : (
                                    ""
                                  )}
                                  <img
                                    src={UploadCameraimg}
                                    alt="camera"
                                    onClick={() => handleBankEditClick(index)}
                                  />
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                    {(mode === "bankib" && activelist.ib === true) ||
                    (mode === "bankcheque" && activelist.bank === true) ? (
                      <ViewPaymentLogsModel
                        transcationcounts={transcationcounts}
                        pay_data={pay_data}
                        mode={mode}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="tab-pane container fade" id="credit-note">
                    <div className="main-body-row-right-col-inner-payment-tabs-card-credit-search com-search-area">
                      <button className="com-search-area-left-img">
                        <img
                          src={
                            base_assets +
                            "images/pos/icons/gift-hamper-icon.png"
                          }
                          alt=""
                        />
                      </button>
                      <input
                        type="text"
                        placeholder="Gift Card number"
                        onChange={(e) => setRefNO(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            searchrefnumber1(); // <-- call your API function here
                          }
                        }}
                      />
                      <button className="btn-style lh-0">
                        <img
                          className="com-search-area-img"
                          src={base_assets + "images/pos/icons/scan-icon.png"}
                          alt=""
                        />
                      </button>
                    </div>
                    {credit_noteoption?.length ? (
                      <>
                        <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box">
                          {credit_noteoption?.length
                            ? credit_noteoption.map((result, creditnotekey) => {
                                return (
                                  <div
                                    className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row "
                                    key={creditnotekey}
                                  >
                                    <div className="com-check">
                                      <input
                                        id={
                                          result?.gift_card_id
                                            ? result?.gift_card_id
                                            : result?.id
                                        }
                                        onClick={(e) =>
                                          getcredit_noteids(
                                            e,
                                            result,
                                            creditnotekey,
                                            result?.gift_card_id ? true : false,
                                          )
                                        }
                                        type="checkbox"
                                        checked={
                                          result?.classadd ? true : false
                                        }
                                        disabled={
                                          balancedue === 0 ||
                                          result?.amount === 0
                                        }
                                      />
                                      <label
                                        htmlFor={
                                          result?.gift_card_id
                                            ? result?.gift_card_id
                                            : result?.id
                                        }
                                        className="com-check-label"
                                      ></label>
                                    </div>
                                    <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right">
                                      <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-name">
                                        <h4 className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-name-heading">
                                          {result?.type}
                                        </h4>
                                        <span className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-name-ref">
                                          {t("Ref No.")} {result?.Ref_No}{" "}
                                        </span>
                                      </div>
                                      <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input">
                                        <span className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input-date">
                                          {result?.date}
                                        </span>
                                        <div
                                          className={
                                            result?.classadd
                                              ? "main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input-field"
                                              : "pe-none border-white"
                                          }
                                        >
                                          <span className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input-field-span">
                                            {result?.currency}
                                          </span>
                                          <input
                                            disabled={
                                              UpdatedCart?.ordertype ===
                                              "pos_order"
                                                ? false
                                                : true
                                            }
                                            className={
                                              result?.classadd
                                                ? "main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input-field-text arrow-none"
                                                : "main-body-row-right-col-inner-payment-tabs-card-credit-box-row-right-input-field-text main-green-text arrow-none"
                                            }
                                            onChange={(e) =>
                                              changecreditnoteamount(
                                                creditnotekey,
                                                parseFloat(e.target.value),
                                                result?.gift_card_id
                                                  ? result?.gift_card_id
                                                  : result?.id,
                                                result?.old_amount,
                                                result?.gift_card_id
                                                  ? true
                                                  : false,
                                              )
                                            }
                                            value={parseFloat(result?.amount)}
                                            type="number"
                                            placeholder=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                          <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row p-0 bg-white">
                            <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-total">
                              {t("Total")}
                            </div>
                            <div className="main-body-row-right-col-inner-payment-tabs-card-credit-box-row-price">
                              {toFormatPrice(
                                credit_noteoption?.length
                                  ? credit_noteoption?.reduce(
                                      (interation, val) =>
                                        (interation = interation + val.amount),
                                      0,
                                    )
                                  : "",
                                { addSymbol: true },
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="main-body-row-right-col-inner-payment-tabs-card-credit-submit">
                          <div className="main-body-row-right-col-inner-payment-tabs-card-credit-submit-value">
                            <input
                              className="main-body-row-right-col-inner-payment-tabs-card-credit-submit-value-text"
                              value={
                                credit_noteids?.length
                                  ? credit_noteids?.reduce(
                                      (interation, val) =>
                                        (interation = parseFloat(
                                          interation + val.amount,
                                        )),
                                      0,
                                    )
                                  : 0
                              }
                              type="text"
                              placeholder=""
                            />
                          </div>
                          <button
                            className={
                              UpdatedCart?.ordertype === "pos_order"
                                ? "btn-style"
                                : "btn-style btn-disabled"
                            }
                            onClick={() => change_creditnote()}
                          >
                            {t("Submit")}
                          </button>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}
            </div>
            {!toggleAddressCustomer && (
              <div
                className={
                  mode === "credit-note" ||
                  (mode === "credit-card" && isActive === false) ||
                  (mode === "bankib" && activelist.ib === false) ||
                  (mode === "bankcheque" && activelist.bank === false)
                    ? "d-none"
                    : `main-body-row-right-col-inner-payment-calculator ${
                        showCalcPopover ? "popover1" : ""
                      }`
                }
              >
                <div
                  className="main-body-row-right-col-inner-payment-calculator-value"
                  ref={inputRef}
                  onClick={() => {
                    if (
                      mode === "cash" ||
                      mode === "bankib" ||
                      mode === "bankcheque"
                    ) {
                      setShowCalcPopover(true);
                      setKeypadMode(mode);
                    }
                  }}
                >
                  <input
                    className={
                      mode === "credit-card" &&
                      repaymentids === "creditcardview"
                        ? "main-body-row-right-col-inner-payment-calculator-value-input pointer-none"
                        : "main-body-row-right-col-inner-payment-calculator-value-input"
                    }
                    pattern="[0.0-9]*"
                    onKeyPress={(e) => {
                      if (e.key !== "Enter") return;
                      if (mode === "bankib") {
                        error(t("Please scan QR code to complete payment"));
                        return;
                      }
                      debitedprice();
                    }}
                    value={calnumbers}
                    onKeyDown={(e) => callnumber(e.key)}
                    placeholder={t("enter amount")}
                    disabled={inputActive}
                    readOnly
                  />
                  <button
                    className="main-body-row-right-col-inner-payment-calculator-value-clear btn"
                    onClick={() => setCalnumbers(calnumbers.slice(0, -1))}
                  >
                    <img
                      className="active"
                      // src={base_assets + "images/pos/icons/clear-btn.png"}
                      src={clrbtnimg}
                      alt=""
                    />
                  </button>
                </div>
                {(mode === "cash" ||
                  mode === "bankib" ||
                  mode === "bankcheque") &&
                  showCalcPopover && (
                    <div
                      className="main-body-row-right-col-inner-payment-calculator-buttons"
                      ref={calcRef}
                    >
                      <div className="main-body-row-right-col-inner-payment-calculator-buttons-num">
                        {calnumber.map((result, key) => {
                          return (
                            <button
                              className={`main-body-row-right-col-inner-payment-calculator-buttons-num-btn ${
                                ["bankib", "bankcheque"].includes(mode)
                                  ? "paymentbuttoncompressed"
                                  : ""
                              }`}
                              onClick={() => callnumber(result)}
                              key={key}
                            >
                              {result}
                            </button>
                          );
                        })}
                      </div>
                      <div className="main-body-row-right-col-inner-payment-calculator-buttons-calculate">
                        <button
                          className="btn clear"
                          onClick={() => setCalnumbers("")}
                        >
                          {t("clear")}
                        </button>
                        {mode === "credit-card" &&
                        repaymentids === "creditcardview" ? (
                          <button
                            className="btn sub"
                            onClick={() => error(t("Not Editable!"))}
                          >
                            {t("sub")}
                          </button>
                        ) : (
                          <button
                            className={`btn sub${
                              mode === "bankib" ? " opacity-50" : ""
                            }`}
                            onClick={() => {
                              UpdatedCart?.installmentarray?.length &&
                              installdivtim?.receive?.length === 0
                                ? error(t("Please Select Installment!"))
                                : repaymentids === "cashid"
                                  ? reCashPayement("", "cashpayment")
                                  : mode === "bankib"
                                    ? error(
                                        t(
                                          "Please scan QR code to complete payment",
                                        ),
                                      )
                                    : debitedprice();
                            }}
                          >
                            {t("sub")}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
        <div className="main-body-row-right-col-inner-footer1">
          {!toggleAddressCustomer && (
            <div className="main-body-row-right-col-inner-payment-price-detail">
              <div className="main-body-row-right-col-inner-payment-price-detail-single">
                <label className="main-body-row-right-col-inner-payment-price-detail-single-text">
                  {t("Cash")}
                </label>
                <span className="main-body-row-right-col-inner-payment-price-detail-single-price">
                  {toFormatPrice(
                    debitedamount?.cash ? debitedamount?.cash : 0,
                    { addSymbol: true },
                  )}
                </span>
              </div>
              <div className="main-body-row-right-col-inner-payment-price-detail-single">
                <label className="main-body-row-right-col-inner-payment-price-detail-single-text">
                  {t("Credit card")}
                </label>
                <span className="main-body-row-right-col-inner-payment-price-detail-single-price">
                  {toFormatPrice(
                    debitedamount?.credit_card ? debitedamount?.credit_card : 0,
                    { addSymbol: true },
                  )}
                </span>
              </div>
              <div className="main-body-row-right-col-inner-payment-price-detail-single">
                <label className="main-body-row-right-col-inner-payment-price-detail-single-text">
                  {t("Bank")}
                </label>
                <span className="main-body-row-right-col-inner-payment-price-detail-single-price">
                  {toFormatPrice(
                    debitedamount?.bank ? debitedamount?.bank : 0,
                    { addSymbol: true },
                  )}
                </span>
              </div>
              <div className="main-body-row-right-col-inner-payment-price-detail-single">
                <label className="main-body-row-right-col-inner-payment-price-detail-single-text">
                  {t("Credit Note")}
                </label>
                <span className="main-body-row-right-col-inner-payment-price-detail-single-price">
                  {toFormatPrice(
                    debitedamount?.credit_notes
                      ? debitedamount?.credit_notes
                      : 0,
                    { addSymbol: true },
                  )}
                </span>
              </div>
            </div>
          )}
          <div className="main-body-row-right-col-inner-footer1-row">
            <span className="main-body-row-right-col-inner-footer1-row-total">
              {UpdatedCart?.sell_info?.status_type === "pos_order" ||
              UpdatedCart?.sell_info?.status_type === "gift_card_order"
                ? t("Grand Total")
                : t("Deposit Amount")}
            </span>
            <span className="main-body-row-right-col-inner-footer1-row-total">
              {toFormatPrice(UpdatedCart?.totalamount, { addSymbol: true })}
            </span>
          </div>
          <div className="main-body-row-right-col-inner-footer1-row">
            <span className="main-body-row-right-col-inner-footer1-row-total">
              {t("Balance Due")}{" "}
            </span>
            <span className="main-body-row-right-col-inner-footer1-row-total-due-amount">
              {toFormatPrice(balancedue, { addSymbol: true })}
            </span>
          </div>
          {!toggleAddressCustomer ? (
            <div className="main-body-row-right-col-inner-footer1-row">
              {(UpdatedCart?.receivestatus === "receivepay" &&
                UpdatedCart?.sell_info?.status_type === "lay_by") ||
              paystatement === "LayBy" ? (
                !saleperson?.value ? (
                  <button
                    onClick={() => error(t("SalePerson is Requried!!"))}
                    className={
                      debitedamount?.cash ||
                      debitedamount?.bank ||
                      debitedamount?.credit_card ||
                      debitedamount?.credit_notes
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                  >
                    {t("Layby")}
                  </button>
                ) : (
                  <button
                    className={
                      debitedamount?.cash ||
                      debitedamount?.bank ||
                      debitedamount?.credit_card ||
                      debitedamount?.credit_notes
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                    data-bs-toggle="modal"
                    data-bs-target="#PayLaybyModal"
                    onClick={() => setLaybyshow(true)}
                  >
                    {t("Layby")}
                  </button>
                )
              ) : installdivtim?.receive?.length ||
                UpdatedCart?.sell_info?.status_type === "Installment" ? (
                !saleperson?.value ? (
                  <button
                    onClick={() => error(t("SalePerson is Requried!!"))}
                    className={
                      balancedue === 0
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                  >
                    {t("Installment")}
                  </button>
                ) : (
                  <button
                    className={
                      balancedue === 0
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                    data-bs-toggle="modal"
                    data-bs-target="#PayInstallModal"
                  >
                    {t("Installment")}
                  </button>
                )
              ) : customer?.id ? (
                !saleperson?.value ? (
                  <button
                    onClick={() => error(t("SalePerson is Requried!!"))}
                    className={
                      balancedue === 0
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                  >
                    {t("check out")}
                  </button>
                ) : UpdatedCart?.ordertype === "refund_order" ? (
                  // <button
                  //   className="btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                  //   data-bs-toggle="modal"
                  //   data-bs-target="#checkoutModal"
                  // >
                  //   {t("check out")}
                  // </button>
                  <button
                    className="btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                    onClick={() => {
                      if (preCheckoutValidation()) {
                        const modal = new window.bootstrap.Modal(
                          document.getElementById("checkoutModal"),
                        );
                        modal.show();
                      }
                    }}
                  >
                    {t("check out")}
                  </button>
                ) : (
                  // <button
                  //   className={
                  //     balancedue === 0
                  //       ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                  //       : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                  //   }
                  //   data-bs-toggle="modal"
                  //   data-bs-target="#checkoutModal"
                  // >
                  //   {t("check out")}
                  // </button>
                  // AFTER — validates first, then opens modal
                  <button
                    className={
                      balancedue === 0
                        ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                        : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                    }
                    onClick={() => {
                      if (preCheckoutValidation()) {
                        const modal = new window.bootstrap.Modal(
                          document.getElementById("checkoutModal"),
                        );
                        modal.show();
                      }
                    }}
                  >
                    {t("check out")}
                  </button>
                )
              ) : (
                <button
                  onClick={() => error(t("Customer is Requried!!"))}
                  className={
                    balancedue === 0
                      ? "btn checkout main-body-row-right-col-inner-footer1-row-btn linear-bg w-100"
                      : "pointer-none btn checkout main-body-row-right-col-inner-footer1-row-btn w-100"
                  }
                >
                  {t("check out")}
                </button>
              )}
            </div>
          ) : (
            ""
          )}
          <p className="footer">{t("© 2026. All rights reserved.")}</p>
        </div>
      </div>
      <div
        className="modal fade common-modal"
        id="checkoutModal"
        tabIndex="-1"
        aria-labelledby="checkoutModalLabel"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="modal-body-img common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text">
                {UpdatedCart?.ordertype === "refund_order"
                  ? t("Do you want to Refund?")
                  : t("Do you want to check out ?")}
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-no"
                data-bs-dismiss="modal"
              >
                {t("No")}
              </button>
              {customer?.id ? (
                generalsettings?.data?.generalsetup
                  ?.Users_to_enter_PIN_for_every_sale === "1" ? (
                  <button
                    type="button"
                    className="btn modal-content-yes"
                    data-bs-toggle="modal"
                    data-bs-target="#pinModal"
                  >
                    {t("yes")}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn modal-content-yes"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      order_edit ? editcheckoutorder() : checkoutorder();
                    }}
                  >
                    {t("yes")}
                  </button>
                )
              ) : (
                <button
                  type="button"
                  className="btn modal-content-yes"
                  onClick={() => error(t("Customer is Requried!!"))}
                >
                  {t("yes")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          showorder === true
            ? "common-modal pin-modal is-open"
            : "modal fade common-modal pin-modal "
        }
        style={showorder ? { display: "block" } : { display: "none" }}
        data-bs-backdrop="false"
        id="pinModal"
        tabIndex="-1"
        aria-labelledby="pinModalLabel"
      >
        {showorder ? (
          paystatement === "LayBy" ||
          checkoutdetails?.order_type === "lay_by" ? (
            <Savelaybymodal checkoutdetails={checkoutdetails} />
          ) : installdivtim.receive.length ? (
            <Saveinstallmentmodal
              checkoutdetails={checkoutdetails}
              installementdata={installementdata}
            />
          ) : (
            <div
              className="common-modal order-successful-modal d-block"
              id="orderSuccessfulModal"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body">
                    <img
                      className="order-successful-modal-img"
                      src={base_assets + "images/pos/icons/check-success.png"}
                      alt=""
                    />
                    <h5 className="order-successful-modal-heading">
                      {t("Order Successful")}
                    </h5>
                    <table className="order-successful-modal-table">
                      <tbody>
                        <tr>
                          <td>{t("Order Summary")}</td>
                          <td>
                            {checkoutdetails?.count} {t("Item")}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td> {t("Grand Total")}</td>
                          <td>
                            <span>
                              {toFormatPrice(
                                parseFloat(checkoutdetails?.totalAmt),
                                { addSymbol: true },
                              )}
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {t("Deposit")} (
                            {UpdatedCart?.sell_info?.summary_order?.deposit}%)
                          </td>
                          <td>
                            <span>
                              {toFormatPrice(checkoutdetails?.deposit_amount, {
                                addSymbol: true,
                              })}{" "}
                            </span>
                          </td>
                        </tr>
                        <tr className="danger-text">
                          <td className="fw-normal">
                            {t("Outstanding Balance")}
                          </td>
                          <td className="fw-normal">
                            <span>
                              {toFormatPrice(checkoutdetails?.outst_bal, {
                                addSymbol: true,
                              })}
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <div className="order-successful-modal-icons">
                      <button
                        className={printparmission ? "btn-style" : "d-none"}
                        disabled={pdfLoading}
                        onClick={async () => {
                          if (pdfLoading) return;
                          setPdfLoading(true);
                          let GetloadingID = loading();
                          try {
                            let res = await _Api(
                              {
                                order_id: checkoutdetails?.id,
                                order_type: checkoutdetails?.order_type,
                                shipping_info: parsedObject,
                              },
                              `api/v1/POS/customOrder/getOrderPdf`,
                            );
                            if (res?.code === 200 && res?.data?.url) {
                              Updateloading(
                                t,
                                GetloadingID,
                                t("PDF opened in new tab"),
                              );
                              window.open(
                                res?.data?.url,
                                "_blank",
                                "noreferrer",
                              );
                            } else {
                              Updateloading(
                                t,
                                GetloadingID,
                                res?.errors || t("Something went wrong"),
                                "error",
                              );
                            }
                          } catch (err) {
                            console.log(err, "err");
                            Updateloading(
                              t,
                              GetloadingID,
                              t("Something went wrong"),
                              "error",
                            );
                          } finally {
                            setPdfLoading(false);
                          }
                        }}
                      >
                        <img
                          src={base_assets + "images/pos/icons/g-printer.png"}
                          alt=""
                        />
                      </button>
                      <button
                        type="button"
                        className="btn-style"
                        onClick={openPosEmailModal}
                      >
                        <img
                          src={base_assets + "images/pos/icons/g-msg.png"}
                          alt=""
                        />
                      </button>
                      {/* <button className='btn-style'>
                          <img src={base_assets + "images/pos/icons/g-upload.png"} alt="" />
                        </button> */}
                    </div>
                    <Link
                      to="/app/pos/menu"
                      className="btn linear-bg order-successful-modal-btn"
                    >
                      {t("BACK TO POS")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : generalsettings?.data?.generalsetup
            ?.Users_to_enter_PIN_for_every_sale === "1" ? (
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button
                type="button"
                className="btn-style close"
                data-bs-dismiss="modal"
                onClick={() => setOtpnumber([])}
              >
                <img
                  src={base_assets + "images/pos/icons/close-green.png"}
                  alt=""
                />
              </button>
              <div className="modal-body">
                <h5 className="pin-modal-heading">{t("Enter PIN")}</h5>
                <div
                  className={
                    "pin-modal-password active-" + otpnumber?.length + ""
                  }
                >
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                  <span className="pin-modal-password-inner">
                    <span className="pin-modal-password-inner-dot"></span>
                  </span>
                </div>
                {/* <button className='pin-modal-forgot btn-style'>{t("Forgot PIN")}</button> */}
                <div className="pin-modal-keys">
                  <div className="pin-modal-keys-row">
                    {[...new Array(10)].map((each, index) => {
                      return otpnumber?.length < 6 ? (
                        <button
                          className="btn-style pin-modal-keys-row-single"
                          onClick={() => {
                            setOtpnumber([
                              ...otpnumber,
                              index === 9 ? 0 : index + 1,
                            ]);
                          }}
                          key={index}
                        >
                          {index === 9 ? 0 : index + 1}
                        </button>
                      ) : (
                        <button
                          className="btn-style pin-modal-keys-row-single"
                          key={index}
                        >
                          {index === 9 ? 0 : index + 1}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    className="btn-style clear"
                    onClick={() => setOtpnumber(otpnumber.slice(0, -1))}
                  >
                    <img
                      src={base_assets + "images/pos/icons/clear-btn.png"}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {loader ? (
        <div className="dot-loader-wrap">
          <div className="dot-loader">
            <div className="dot-loader-dot dot1"></div>
            <div className="dot-loader-dot dot2"></div>
            <div className="dot-loader-dot dot3"></div>
            <div className="dot-loader-dot dot4"></div>
            <div className="dot-loader-dot dot5"></div>
            <div className="dot-loader-dot dot6"></div>
            <div className="dot-loader-dot dot7"></div>
            <div className="dot-loader-dot dot8"></div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="confirmPopupHandler">
        <CustomerInformation cusid={cusid} setCusid={setCusid} />
      </div>
      <div
        className="modal fade installment-modal common-modal"
        id="installmentModal"
        tabIndex="-1"
        aria-labelledby="installmentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("Installment")}
              </h5>
              <button
                type="button"
                className="btn-close shadow-none"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setinstallcof(false)}
              >
                <img
                  className="date-img"
                  src={base_assets + "images/pos/icons/close-green.png"}
                  alt=""
                />
              </button>
            </div>
            <div className="modal-body">
              <div className="installment-modal-grand-total installment-modal-price-area">
                <span>{t("Grand Total")}</span>
                <span>
                  {toFormatPrice(UpdatedCart?.totalamount, { addSymbol: true })}
                </span>
              </div>
              <div className="installment-modal-select-row d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  {t("Installment")}
                  <div className="placeholder-up-input col">
                    <Select
                      className="Select"
                      placeholder={t("Installment")}
                      options={installdivide}
                      value={installdivtim?.installment}
                      components={{
                        ValueContainer: CustomValueContainer,
                      }}
                      classNamePrefix="common-select"
                      onChange={(e) =>
                        setinstalldivtim((existing) => ({
                          ...existing,
                          installment: { label: e?.label, value: e?.value },
                        }))
                      }
                      getOptionLabel={(e) => <div className="">{e.label}</div>}
                      isSearchable={false}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  Term
                  <div className="placeholder-up-input col ">
                    <Select
                      className="Select"
                      placeholder="Term"
                      value={installdivtim?.term}
                      options={installtime}
                      components={{
                        ValueContainer: CustomValueContainer,
                      }}
                      classNamePrefix="common-select"
                      onChange={(e) =>
                        setinstalldivtim((existing) => ({
                          ...existing,
                          term: { label: e?.label, value: e?.value },
                        }))
                      }
                      getOptionLabel={(e) => <div className="">{e.label}</div>}
                      isSearchable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="installment-modal-detail">
                <table className="w-100 text-nowrap">
                  <tbody>
                    <>
                      {installementdata?.length > 0 &&
                        installementdata?.map((ins, i) => (
                          <tr
                            className={
                              installdivtim?.receive?.filter(
                                (obj) => obj.id === "inst_" + i,
                              )?.length
                                ? "active"
                                : ins?.paid === 0
                                  ? ""
                                  : "active"
                            }
                            onClick={() => {
                              if (ins?.paid === 0) {
                                if (
                                  installdivtim?.receive.filter(
                                    (obj) => obj.id === "inst_" + i,
                                  )?.length
                                ) {
                                  removeidsoninstrecieve(i);
                                } else {
                                  setinstalldivtim((existing) => ({
                                    ...existing,
                                    receive: [
                                      ...existing?.receive,
                                      {
                                        amount: ins?.amount,
                                        id: ins?.id,
                                        paid: 1,
                                        date: ins?.date,
                                        formatted_date: ins?.formatted_date,
                                        key: i + 1,
                                      },
                                    ],
                                  }));
                                }
                              }
                            }}
                            key={i}
                          >
                            <td>
                              {ins?.paid === 0 ? (
                                <svg
                                  className="installment-modal-detail-tick"
                                  width="20"
                                  height="21"
                                  viewBox="0 0 20 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.99844 20.0984C12.5445 20.0984 14.9863 19.087 16.7867 17.2867C18.587 15.4863 19.5984 13.0445 19.5984 10.4984C19.5984 7.95236 18.587 5.51056 16.7867 3.71021C14.9863 1.90986 12.5445 0.898438 9.99844 0.898438C7.45236 0.898438 5.01056 1.90986 3.21021 3.71021C1.40986 5.51056 0.398438 7.95236 0.398438 10.4984C0.398438 13.0445 1.40986 15.4863 3.21021 17.2867C5.01056 19.087 7.45236 20.0984 9.99844 20.0984ZM14.4468 8.94684C14.6654 8.72051 14.7864 8.41739 14.7836 8.10276C14.7809 7.78812 14.6547 7.48715 14.4322 7.26466C14.2097 7.04217 13.9088 6.91596 13.5941 6.91323C13.2795 6.91049 12.9764 7.03145 12.75 7.25004L8.79844 11.2016L7.24684 9.65004C7.02051 9.43145 6.71739 9.3105 6.40276 9.31323C6.08812 9.31596 5.78715 9.44217 5.56466 9.66466C5.34217 9.88715 5.21596 10.1881 5.21323 10.5028C5.21049 10.8174 5.33145 11.1205 5.55004 11.3468L7.95004 13.7468C8.17507 13.9718 8.48024 14.0982 8.79844 14.0982C9.11664 14.0982 9.4218 13.9718 9.64684 13.7468L14.4468 8.94684Z"
                                    fill="#D9D9D9"
                                  />
                                </svg>
                              ) : (
                                <div className="installment-modal-detail-paid">
                                  {t("PAID")}
                                </div>
                              )}
                            </td>
                            <td className="installment-modal-detail-s-no">
                              {i + 1}
                            </td>
                            <td className="w-100">{ins?.date}</td>
                            <td className="ms-auto text-end">
                              {toFormatPrice(ins?.amount, { addSymbol: true })}
                            </td>
                          </tr>
                        ))}
                    </>
                  </tbody>
                </table>
              </div>
              <div className="installment-modal-price-area">
                <span>{t("Receive")}</span>
                <span>
                  {toFormatPrice(
                    installdivtim?.receive?.reduce(
                      (interation, val) =>
                        (interation = interation + parseFloat(val.amount)),
                      0,
                    ),
                    { addSymbol: true },
                  )}
                </span>
              </div>
              <div className="installment-modal-price-area delivered-text">
                <span>{t("Outstanding Balance")} </span>
                <span>{toFormatPrice(balancedue, { addSymbol: true })}</span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="com-btn com-btn-outline"
                data-bs-dismiss="modal"
                onClick={() => setinstallcof(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                data-bs-dismiss="modal"
                className="com-btn"
                onClick={() => {
                  setBalancedue(
                    installdivtim?.receive?.reduce(
                      (interation, val) =>
                        (interation = interation + parseFloat(val.amount)),
                      0,
                    ),
                  );
                  setinstallcof(true);
                }}
              >
                {t("Confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="imagePreviewModal"
        tabIndex="-1"
        aria-labelledby="imagePreviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content border-0"
            style={{ backgroundColor: "#000", height: "28vw" }}
          >
            {/* Close Button */}
            <div className="border-0 p-2">
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Image */}
            <div
              className="modal-body text-center p-0"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={modalImage}
                alt="Preview"
                className="img-fluid rounded"
                style={{ maxWidth: "25vw", maxHeight: "25vw" }}
              />
            </div>
          </div>
        </div>
      </div>
      <EmailModal
        type={UpdatedCart?.sell_info?.status_type}
        email={checkoutdetails?.email}
        id={checkoutdetails?.id}
        setShoworder={setShoworder}
      />
      <PaymentLayby
        balancedue={balancedue}
        debitedamount={debitedamount}
        Grand_Total={greandtotal ? greandtotal : UpdatedCart?.totalamount}
        setTransactionlaybyDate={setTransactionlaybyDate}
        TransactionlaybyDate={TransactionlaybyDate}
        setPay_layby_data={setPay_layby_data}
        pay_layby_data={pay_layby_data}
        laybyshow={laybyshow}
        laybylist={laybylist}
        onConfirm={() => {
          order_edit ? editcheckoutorder() : checkoutorder();
        }}
        pinRequired={
          generalsettings?.data?.generalsetup
            ?.Users_to_enter_PIN_for_every_sale === "1"
        }
      />
      <PaymentInstall
        installment={installdivtim?.receive}
        Grand_Total={UpdatedCart?.totalamount}
        installdivtim={installdivtim}
        installementdata={installementdata}
        onConfirm={() => {
          order_edit ? editcheckoutorder() : checkoutorder();
        }}
        pinRequired={
          generalsettings?.data?.generalsetup
            ?.Users_to_enter_PIN_for_every_sale === "1"
        }
      />
    </>
  );
};

export default CheckoutPayment;
